const callstackgif = new URL(
  "../../img/javascript/callstack.gif",
  import.meta.url
).href;
const callbackqueue = new URL(
  "../../img/javascript/callbackqueue.gif",
  import.meta.url
).href;
const microtaskqueue = new URL(
  "../../img/javascript/microtaskqueue.gif",
  import.meta.url
).href;
const closure1 = new URL("../../img/javascript/closure1.png", import.meta.url)
  .href;

export const javascriptContent = /* html */ `

<div data-id="javascript-conditionals" class="level1-container">
  <h1 class="header">Conditionals</h1>
  <div data-id="conditionals-ternary operator">
    <h2>Ternary operator</h2>
    <pre><code class="language-javascript">
        letter === "A" ? console.log('Letter is A') : console.log('Letter is not A');
    </code></pre>
  </div>

  <div data-id="conditionals-switch">
    <h2>Switch</h2>
    <pre><code class="language-javascript">
        switch (animal) {
          case 'cat': console.log('Meow'); break;
          case 'dog': console.log('Woof'); break;
          default: console.log('Sleeping...');
        }
    </code></pre>
  </div>
</div> 

<!-- STRINGS -->

<div data-id="javascript-strings" class="level1-container"> 
  <h1>Strings</h1>

  <div data-id="strings-template literals">
    <h2>Template literals</h2>
    <div class="info">Template literals make it easy to combine variables and expressions with strings.<br> Just use &#36;{expression} between backticks &#96; &#96; (Alt Gr + µ on Windows).</div>
    <pre><code class="language-javascript">
        const name = 'Matthias';
        console.log(&#96;Hello &#36;{name}&#96;);

        console.log(&#96;Billy is &#36;{6+8} years old.&#96;);

        console.log(&#96;Jack is &#36;{calcAge()} years old.&#96;);
    </code></pre>
  </div>

  <div data-id="strings-string operations">
  
     <h2>String operations</h2>
    <div class="largesection">
      <h3>Properties</h3>
      <pre><code class="language-javascript">
        // Get the length of a string
        const length = myString.length;
        const length = 'Autumn8'.length;
      </code></pre>

      <h3>Index-based operation</h3>
      <pre><code class="language-javascript">
        // Index of first occurrence
        const firstIndex = myString.indexOf('r'); 

        // Index of last occurrence
        const lastIndex = myString.lastIndexOf('r');

        // .indexOf() and .lastIndexOf() can check for character sequences
        const index = myString.indexOf('Autumn8');

        // Returns the character at the given index
        const firstCharacter = myString.at(0);
        const lastCharacter = myString.at(-1);
      </code></pre>

      <h3>Substring operations</h3>
      <pre><code class="language-javascript">
        const substr = myString.slice(4);
        const substr = myString.slice(4, 7);
        const substr = myString.slice(0, myString.indexOf(' '));
        const substr = myString.slice(-2);
        const substr = myString.slice(1, -1);
      </code></pre>

      <h3>Case conversion</h3>
      <pre><code class="language-javascript">
        const lowered = myString.toLowerCase();
        const capitalized = myString.toUpperCase();
      </code></pre>

      <h3>Whitespace removal</h3>
      <pre><code class="language-javascript">
        const trimmed = myString.trim();
        const trimmed = myString.trimStart();
        const trimmed = myString.trimEnd();
      </code></pre>

      <h3>String replacement</h3>
      <pre><code class="language-javascript">
        const newString = myString.replace('cat', 'dog');
        const newString = myString.replaceAll('cat', 'dog');
      </code></pre>

      <h3>String testing</h3>
      <pre><code class="language-javascript">
        const aBoolean = myString.includes('cat');
        const aBoolean = myString.startsWith('cat');
        const aBoolean = myString.endsWith('dog');
      </code></pre>

      <h3>String splitting</h3>
      <pre><code class="language-javascript">
        const anArray = myString.split(' ');
        const [ firstName, lastName ] = 'Matthias Swerts'.split(' ');
      </code></pre>

      <h3>Padding and repeating</h3>
      <pre><code class="language-javascript">
        const padded = myString.padStart(10, '_');
        const padded = myString.padEnd(10, '_');
        const fiveTimes = myString.repeat(5);
      </code></pre>
    </div>
  </div><!-- end  string operations-->
  <diV data-id="strings-string conversion">
  <h2>String conversion</h2>
  <div class="info">Concatenating a string with another type using '+' will coerce the result to a string</div>
  <pre><code class="language-javascript">
        console.log('The result is ' + 42); // Output: "The result is 42"
        console.log(true + ''); "true"

        console.log(typeof String(42)); // Output: string  
      
        console.log(typeof (42).toString()); // Output: string  

        // String() never fails, while .toString() fails on null/undefined. So String() is better for general use
    </code></pre>
  </diV>
</div><!-- end strings -->


<!-- LOOPS -->

<div data-id="javascript-loops" class="level1-container"> 
  <h1>Loops</h1>
  <div class="smallspacer"></div>
  <div class="info">
    <ul>
      <li>Continue: breaks the loop sequence but continues with the next iteration</li>
      <li>Break: stops the loop completely</li>
    </ul>
  </div>

  <table>
    <thead>
      <tr>
        <th>Feature</th>
        <th>for</th>
        <th>for...of</th>
        <th>forEach</th>
        <th>for...in</th>
        <th>while</th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td>Works on</td>
        <td>Arrays</td>
        <td>All iterables <a href="https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Iteration_protocols" target="_blank" rel="noopener noreferrer">(mdn)</a></td>
        <td>Arrays, Maps, Sets</td>
        <td>Objects (enumerable properties)</td>
        <td>Any condition</td>
      </tr>
      <tr>
        <td>Breaking/Skipping</td>
        <td>Yes</td>
        <td>Yes</td>
        <td>No</td>
        <td>Yes</td>
        <td>Yes</td>
      </tr>
      <tr>
        <td>Asynchronous Support</td>
        <td>No</td>
        <td>for await...of available</td>
        <td>No</td>
        <td>No</td>
        <td>No</td>
      </tr>
      <tr>
        <td>Use Case</td>
        <td>Precise control over iteration</td>
        <td>Traversing any iterable</td>
        <td>Simple operations<br>Functional style</td>
        <td>Iterating over object properties</td>
        <td>Unknown number of iterations</td>
      </tr>
    </tbody>
  </table>

  <div class="smallspacer"></div>

<table>
  <thead>
    <tr>
      <th>Data structure</th>
      <th>Return value of .entries()</th>
      <th>Default return value in for...of</th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td>Array</td>
      <td>Iterator of index-value pairs</td>
      <td>Values</td>
    </tr>
    <tr>
      <td>Object</td>
      <td>Array of key-value pairs (via Object.entries(obj))</td>
      <td>Not directly iterable</td>
    </tr>
    <tr>
      <td>Map</td>
      <td>Iterator of key-value pairs</td>
      <td>Key-value pairs</td>
    </tr>
    <tr>
      <td>Set</td>
      <td>Iterator of value-value pairs</td>
      <td>Values</td>
    </tr>
  </tbody>
</table>

<div data-id="loops-iterables">
  <details class="collapsible">
    <summary>Advanced info: What is an iterable?</summary>
    <div class="info">
      An <b>iterable</b> is any object that has a [Symbol.iterator] method.
      <pre><code class="language-javascript">
        typeof [][Symbol.iterator]     // 'function' -&gt; iterable
        typeof {}[Symbol.iterator]     // 'undefined' -&gt; not iterable
      </code></pre>
      <b>Symbol</b> is a primitive type (like string or number) whose only guarantee is uniqueness: every <code>Symbol()</code> call produces a brand new value, never equal to any other. JS ships a handful of built-in "well-known" symbols for its own internal hooks, and <code>Symbol.iterator</code> is one of them: it's just a reserved, collision-proof property key.<br /><br />
      The method is accessed on the object through <b>computed property access:</b> <br /><code>obj.key</code> and <code>obj['key']</code> both use the hardcoded name "key". <br /><code>obj[expression]</code> is different: JS evaluates the expression first, and uses that result as the property name.<br /><br />

      Computed property access example:<br />
      <pre><code class="language-javascript">
        const key = 'age';
        const person = { age: 30 };

        person.key      // undefined -&gt; looks for a property literally named "key"
        person['key']   // undefined -&gt; same, "key" is a string here too
        person[key]     // 30 -&gt; evaluates variable key first, gets "age", then looks that up
      </code></pre><br />
      <code>Symbol.iterator</code> works the same way: it's just an expression that evaluates to one specific, built-in Symbol value. So <code>obj[Symbol.iterator]</code> evaluates <code>Symbol.iterator</code> first, then looks up the property whose key is <i>that exact Symbol value</i> &mdash; not the text "Symbol.iterator":
      <pre><code class="language-javascript">
        obj[Symbol.iterator]      // correct: key = the Symbol value itself
        obj['Symbol.iterator']    // wrong: key = the literal string "Symbol.iterator"
        obj.Symbol.iterator       // wrong: looks for a property called "Symbol" first
      </code></pre>
    </div>
    <div class="info">
      <b>Iterable protocol:</b> an object is iterable simply by having a method at that key, <code>obj[Symbol.iterator]</code>. Calling it (no arguments) must return an <b>iterator</b>. An iterator is just an object that has a .next() function.<br /> Because the key is a Symbol rather than a string, this property never shows up in <code>Object.keys()</code>, <code>for...in</code> or <code>JSON.stringify()</code>.<br /><br />
     That returned iterator must have a <code>.next()</code> method. Each call returns a plain object <code>{ value, done }</code>:
      <ul>
        <li><code>value</code>: the item produced by this step</li>
        <li><code>done</code>: false while more values are coming, true once the iterator is exhausted (value is then usually undefined)</li>
      </ul>
      <pre><code class="language-javascript">
        const arr = [10, 20];
        const it = arr[Symbol.iterator](); // iterable protocol: get the iterator

        it.next(); // { value: 10, done: false }
        it.next(); // { value: 20, done: false }
        it.next(); // { value: undefined, done: true }
      </code></pre>
      <br />
      for...of, array-style spread (<code>[...x]</code>) and array destructuring (<code>const [a, b] = x</code>) all use the same <code>Symbol.iterator</code> behind the scenes to fetch the values one by one, which is why all three fail on a plain object.<br />
      Object-style spread (<code>{...x}</code>) and object destructuring (<code>const { a } = x</code>) don't use an iterator behind the scenes, they just copy properties by name, so they work on any object.
    </div>
    <table>
      <thead>
        <tr>
          <th>Data structure</th>
          <th>Iterable by default?</th>
          <th>Why</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>Array</td>
          <td>Yes</td>
          <td>Has a built-in [Symbol.iterator]</td>
        </tr>
        <tr>
          <td>String</td>
          <td>Yes</td>
          <td>Has a built-in [Symbol.iterator] (iterates per character)</td>
        </tr>
        <tr>
          <td>Map</td>
          <td>Yes</td>
          <td>Has a built-in [Symbol.iterator]</td>
        </tr>
        <tr>
          <td>Set</td>
          <td>Yes</td>
          <td>Has a built-in [Symbol.iterator]</td>
        </tr>
        <tr>
          <td>Object</td>
          <td>No</td>
          <td>Plain objects have no [Symbol.iterator] &mdash; convert with Object.entries/keys/values first</td>
        </tr>
      </tbody>
    </table>
  </details>
  </div>

  <div data-id="loops-for">
    <h2>For loop</h2>
    <pre><code class="language-javascript">
        const numbers = [1, 2, 3, 4];

        for (let i = 0; i &lt; numbers.length; i++) {
          if (numbers[i] === 2) continue; // Skips the number 2
          console.log(&#96;Element: &#36;{numbers[i]}, Index: &#36;{i}&#96;);
        }
    </code></pre>
  </div>

  <div data-id="loops-for of">
    <h2>For-of loop</h2>
    <div class="info">For-of works on anything that is iterable, so the same syntax covers arrays, maps, sets and strings</div>

    <h3>For-of with arrays</h3>
    <pre><code class="language-javascript">
        const animals = ['cat', 'dog', 'turtle'];

        for (const animal of animals){
          console.log(animal);
        }
    </code></pre>

    <h3>Accessing index using entries</h3>
    <div class="info">
          The 'entries' method of an array returns an array of arrays containing the index and the element:<br>
          [[0, 'cat'], [1, 'dog'], [2, 'turtle']]<br><br>
          Entries() will return the next array on each iteration.<br> Since it returns an array it can be destructured using [i, el]
    </div>
    <pre><code class="language-javascript">
        const animals = ['cat', 'dog', 'turtle'];

        for (const [index, animal] of animals.entries()){
          console.log(&#96;The animal &#36;{animal} is at index &#36;{index}&#96;);
        }
    </code></pre>

    <h3>For-of with maps</h3>
    <div class="info">A map returns key-value pairs by default, so they can be destructured straight away</div>
    <pre><code class="language-javascript">
        const yearsOld = new Map([['Matthias', 34], ['Toon', 65]]);

        for (const [name, age] of yearsOld){
          console.log(&#96;&#36;{name} is &#36;{age} years old.&#96;);
        }

        // Looping over only the keys or only the values
        for (const name of yearsOld.keys()){
          console.log(name);
        }

        for (const age of yearsOld.values()){
          console.log(age);
        }
    </code></pre>

    <h3>For-of with sets</h3>
    <div class="info">A set returns its values directly. It has no index, so there is no counterpart to an array's entries()</div>
    <pre><code class="language-javascript">
        const names = new Set(['Matthias', 'Toon', 'Loesje']);

        for (const name of names){
          console.log(&#96;Hello &#36;{name}&#96;);
        }
    </code></pre>

    <h3>For-of with strings</h3>
    <div class="info">A string is iterable too, so it can be looped character by character</div>
    <pre><code class="language-javascript">
        const species = 'otter';

        for (const letter of species){
          console.log(letter);
        }
    </code></pre>

    <h3>For-of with objects</h3>
    <div class="info">An object is not iterable, so it has to be converted first</div>
    <pre><code class="language-javascript">
        const otter = { name: 'Ollie', weight: 8 };

        for (const [key, value] of Object.entries(otter)){
          console.log(&#96;&#36;{key}: &#36;{value}&#96;);
        }
    </code></pre>
  </div>

  <div data-id="loops-for each">
    <h2>For-each loop</h2>
    <h3>For-each with arrays</h3>
    <div class="info">The foreach cbfn on an array accepts the <b>element, the index, and the entire array</b></div>
    <pre><code class="language-javascript">
        const animals = ['cat', 'dog', 'turtle'];

        // With element
        animals.forEach(animal => {
          console.log(&#96;&#36;{animal}&#96;)  
        });

        // With element and index
        animals.forEach(function (animal, index) {
          console.log(&#96;Animal &#36;{animal} is at index &#36;{index}&#96;); 
        });

        // With element, index and entire array
        animals.forEach(function (animal, index, array) {
          console.log(&#96;Animal &#36;{animal} is at index &#36;{index}&#96;);
          console.log(&#96;The total amount of animals is &#36;{array.length}&#96;)  
        });
    </code></pre>

    <h3>For-each with maps</h3>
    <div class="info">The foreach cbfn on a map accepts the <b>value, key and the entire map</b></div>
    <pre><code class="language-javascript">
        const yearsOld = new Map([
          ['Matthias', '34'],
          ['Toon', '65'],
          ['Loesje', '32']
        ]);

        // With value
        yearsOld.forEach(function (age) {
          console.log(&#96;Age: &#36;{age}&#96;);
        });

        // With value and key
        yearsOld.forEach(function (age, name) {
          console.log(&#96;&#36;{name} is &#36;{age} years old.&#96;);
        });

        // With value, key and entire map
        yearsOld.forEach(function (age, name, entireMap) {
          console.log(&#96;&#36;{name} is &#36;{age} years old.&#96;);
          console.log(&#96;There are &#36;{entireMap.size} values in the map.&#96;);
        });
    </code></pre>

    <h3>For-each with sets</h3>
    <div class="info">The foreach cbfn on a set accepts the <b>value, value again </b>(since sets don't have keys)<b> and the entire set</b></div>
    <pre><code class="language-javascript">
        const names = new Set(['Matthias', 'Toon', 'Loesje']);

        // With value
        names.forEach(function (name) {
          console.log(&#96;Hello &#36;{name}&#96;);
        });

        // With value and entire set, we skip the second parameter with _ 
        // because it's just the value again..
        names.forEach(function (name, _, entireSet) {
          console.log(&#96;Hello &#36;{name}&#96;);
          console.log(&#96;There are &#36;{entireSet.size} values in the set.&#96;);
        });
    </code></pre>
  </div>

  <div data-id="loops-for in">
  <h2>For...in loop</h2>
  <div class="info">
  Avoid using 'for...in' on arrays because it may include unexpected
  properties from the array's prototype</div>
  <pre><code class="language-javascript">
        const obj = { a: 1, b: 2, c: 3 };

        for (const key in obj) {
          console.log(&#096;&#036;{key}: &#036;{obj[key]}&#096;);
        }
        // Output:
        // a: 1
        // b: 2
        // c: 3

        // for...in includes inherited properties
        const parent = { inheritedProp: 'I am inherited' };
        const child = Object.create(parent); // child inherits from parent
        child.ownProp = 'I am own';

        for (const key in child) {
          console.log(key);
        }
        // Output:
        // ownProp
        // inheritedProp

        /* To exclude inherited properties, use the Object.hasOwn() method */

        const parent = { inheritedProp: 'I am inherited' };
        const child = Object.create(parent);
        child.ownProp = 'I am own';

        for (const key in child) {
          if (Object.hasOwn(child, key)) {
            console.log(key); // Output: ownProp
          }
        }
  </code></pre>
  </div>

  <div data-id="loops-while">
  <h2>While and do...while</h2>
  <div class="info">
  Use a while loop when you don't know upfront how many iterations you need: it keeps running as long as the condition is true. A do...while runs its body at least once, because the condition is only checked after each iteration.</div>
  <pre><code class="language-javascript">
        // while: condition is checked before every iteration
        let seeds = 3;

        while (seeds &gt; 0) {
          console.log(&#096;Planting seed &#036;{seeds}&#096;);
          seeds--;
        }
        // Output:
        // Planting seed 3
        // Planting seed 2
        // Planting seed 1

        // do...while: body runs first, condition is checked afterwards
        let attempts = 0;
        let roll;

        do {
          roll = Math.trunc(Math.random() * 6) + 1;
          attempts++;
        } while (roll !== 6);

        console.log(&#096;Rolled a 6 after &#036;{attempts} attempt(s)&#096;);

        // The condition must eventually become false, or the loop never ends.
        // while (true) { ... } is only acceptable when a break inside exits it.
  </code></pre>
  </div>
</div>

<!-- FUNCTIONS -->

<div data-id="javascript-functions" class="level1-container">
  <h1>Functions</h1>
  <div data-id="functions-arrow functions">
    <h2>Arrow functions</h2>
    <div class="info">
      <ul>
        <li>If an arrow function is a single expression, that expression is implicitly returned</li>
        <li>Parentheses () for parameters are optional when using 1 parameter</li>
        <li>Curly braces {} for the function body are mandatory when more than one expression is used OR there is an explicit return statement</li>
      </ul>
    </div> <!-- end info arrow function -->

    <h3>No parameters</h3>
    <pre><code class="language-javascript">
        const printHello = () => {
          console.log('hello');
        };
        printHello(); 
    </code></pre>

    <h3>Single parameter</h3>
    <pre><code class="language-javascript">
        const printAge = yearsOld => {
          console.log(&#96;You are &#36;{yearsOld} years old.&#96;);
        };
        printAge(24);
    </code></pre>

    <h3>Multiple parameters</h3>
    <pre><code class="language-javascript">
        const sum = (firstParam, secondParam) => {
          return firstParam + secondParam;
        };
        console.log(sum(2, 5));
    </code></pre>

    <h3>Single expression</h3>
    <pre><code class="language-javascript">
        const addOne = (n) => n + 1;
        console.log(addOne(1)); 

        const multiply = (a, b) => a * b;
        console.log(&#96;The answer is: &#36;{multiply(2, 20)}&#96;);
    </code></pre>
  </div> <!-- end arrow functions -->

  <div data-id="functions-function declaration">
    <h2>Function declaration</h2>
    <pre><code class="language-javascript">
        function sum(num1, num2) {
          return num1 + num2;
        };

        sum(1, 1);
    </code></pre>
  </div> <!-- end function declarations -->

  <div data-id="functions-function expression">
    <h2>Function expression</h2>
    <pre><code class="language-javascript">
        const dog = function() {
          return 'Woof!';
        }

        dog();
    </code></pre>
  </div> <!-- end function expressions -->

  <div data-id="functions-default function values">
    <h2>Default function values</h2>
    <pre><code class="language-javascript">
        const numGuests = 2;
        const ginTonic = function (gin = 1, tonic, soda = 0.5 * numGuests) {
          console.log(gin, tonic, sode);
        };

        ginTonic(undefined, '1ABC'); // The result will print '1, 1ABC, 1'  
    </code></pre>
  </div> <!-- end function values -->

  <div data-id="functions-callback and higher order functions">
    <h2>Callback and higher-order functions</h2>
    <div class="info">
      Functions that accept callback functions or create other functions are called 'higher-order functions'<br>
      In the example below, printLetter() is a higher-order function.<br>
      A and B are callback functions
    </div> <!-- end info higher order functions -->

    <pre><code class="language-javascript">
        // Passing callback functions A and B into higher-order function printLetter
        const A = function () { return 'A' };
        const B = function () { return 'B' };

        const printLetter = fnc => console.log(fnc);

        printLetter(A); // Logs 'A'
        printLetter(B); // Logs 'B'

        // Returning an anonymous function from a higher-order function
        const greet = function (greeting) {
          return function (name) {
            console.log(&#96;&#36;{greeting} &#36;{name}&#96;);
          }
        }

        const greeterHey = greet('Yo'); // Sets the greeting parameter to 'Yo'
        greeterHey('Matthias'); // Logs 'Yo Matthias'
        greet('Hi')('Matthias') // Logs 'Hi Matthias'

        // Rewriting greet() in an arrow function looks pretty crazy
        const greet = greeting => name => console.log(&#96;&#36;{greeting} &#36;{name}&#96;);
    </code></pre>
  </div> <!-- end higher order functions -->

  <div data-id="functions-immediately invoked function expressions">
    <h2>Immediately invoked function expressions (IIFE)</h2>
    <div class="info">
        IIFE's are functions that only run once. <br>
        By placing a function expression between parentheses, the expression (value) turns into a statement (action). <br><br>
        In the past it was used to encapsulate (privatise and protect) variables by placing them inside the IIFE function block, since nothing can reach it that way.<br>
        Nowadays we can just create a scope block using curly braces, which makes the variables and functions limited to that block scope
    </div> <!-- end info IIFE -->

    <pre><code class="language-javascript">
        // Anonymous IIFE
        (function(){
          console.log('This will run only once');
        })();

        // Anonymous arrow IIFE
        (() => console.log('This wil run only once'))();
    </code></pre>
  </div> <!-- end IIFE -->

  <div data-id="functions-closures">
    <h2>Closures</h2>
    <h3>Creating a closure</h3>
    <div class="info">
      <i>A function has access to the variable environment of the execution context in which is was created.</i><br>
      In human language that says: "A function has access to it's birthplace's variables".<br><br>
      The variables in the closure are not directly acessible like fe. an object. But are useable by the returned function.<br><br>
      Variables inside a closure have priority over the scope chain. Meaning that even if there was a global variable called x, the variable x in the function would be increased instead.
    </div> <!-- end closure info -->

    <pre><code class="language-javascript">
        const x = 1111;

        const functionWithVariable = function() {
          let x = 0;

          return function(){
              console.log(&#96;&#36;{++x}&#96;); 
          };
        };

        // Calling the returned function will increase x
        // even though there is no variable x inside the returned function
        functionWithVariable()(); // Output: 1

        const increase = functionWithVariable();
        increase(); // Output: 1
        increase(); // Output: 2
    </code></pre>

    <div class="smallspacer"></div>

    <div class="info">
      Inspecting the function (in chrome) will show the variables in the closure
    </div>

    <div class="image-container">
      <img src="${closure1}" alt="Closure-Image" />
    </div>
    <br>
    <h3>Reassigning closures</h3>

    <pre><code class="language-javascript">
        // When a() is called, the function assigned to closureFun is born
        // and has closure over the variables of a()
        let closureFun;
        const a = function () {
          const aNumber = 23;
          closureFun = function () { 
            console.log(aNumber);
          };
        };

        // When b() is called, the function assigned to closureFun() is 'reborn'
        // and has closure over the variables of b()
        const b = function () {
          const anotherNumber = 777;
          closureFun = function () { 
            console.log(anotherNumber);
          };
        };

        a(); // assigns its function to closureFun
        closureFun(); // Output: 23
        b(); // assigns its function to closureFun
        closureFun(); // Output: 777
    </code></pre>
    <br>
    <h3>Closure example with setTimeout()</h3>
    <div class="info">
      The code example below has a function that triggers long after it's parent function has been processed.<br>
      Even then the created function has access to the variables of it's parent.
    </div>
    <pre><code class="language-javascript">
        const cookChicken = function (guests, wait){
          const chickens = 4;
          const perPerson = chickens / 4;

          setTimeout ( 
            function () {
              console.log(&#96;I am cooking for &#36;{guests} guests&#96;);
              console.log(&#96;There are &#36;{chickens} chickens, that's &#36;{perPerson} chicken pp&#96;)
            }
          , wait * 1000});

          console.log(&#96;I will start cooking in &#36;{wait} seconds&#96;)
        }

        cookChicken(4, 2); 
        // This will output:
        // 'I will start cooking in 2 seconds', meaning the cookChicken() function was resolved
        // 'I am cooking for 4 guests'
        // 'There are 4 chickens, that's 1 chicken pp'
        // Meaning the cbfn in setTimeout() still has access to those variables
    </code></pre>
  </div>  
</div> <!-- end javascript functions -->

<!-- DATA STRUCTURES -->
<div data-id="javascript-data structures" class="level1-container"> 
  <div data-id="data structures-overview">
  <h1>Data structures overview</h1>

  <h2>Overview</h2>
  <table>
    <thead>
      <tr>
        <th>Usage</th>
        <th>Array</th>
        <th>Object</th>
        <th>Map</th>
        <th>Set</th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td>Ordered list (index access)</td>
        <td><i class="fa fa-check checkmark"></i></td>
        <td><i class="fa fa-ban cross"></i></td>
        <td><i class="fa fa-ban cross"></i></td>
        <td><i class="fa fa-ban cross"></i></td>
      </tr>
      <tr>
        <td>Key-value pairs</td>
        <td><i class="fa fa-ban cross"></i></td>
        <td><i class="fa fa-check checkmark"></i></td>
        <td><i class="fa fa-check checkmark"></i></td>
        <td><i class="fa fa-ban cross"></i></td>
      </tr>
      <tr>
        <td>Unique values (no duplicates)</td>
        <td><i class="fa fa-ban cross"></i></td>
        <td><i class="fa fa-ban cross"></i></td>
        <td><i class="fa fa-ban cross"></i></td>
        <td><i class="fa fa-check checkmark"></i></td>
      </tr>
      <tr>
        <td>Non-string keys</td>
        <td><i class="fa fa-ban cross"></i></td>
        <td><i class="fa fa-ban cross"></i></td>
        <td><i class="fa fa-check checkmark"></i></td>
        <td><i class="fa fa-ban cross"></i></td>
      </tr>
      <tr>
        <td>Directly iterable (for...of)</td>
        <td><i class="fa fa-check checkmark"></i></td>
        <td><i class="fa fa-ban cross"></i></td>
        <td><i class="fa fa-check checkmark"></i></td>
        <td><i class="fa fa-check checkmark"></i></td>
      </tr>
      <tr>
        <td>Works directly with JSON</td>
        <td><i class="fa fa-check checkmark"></i></td>
        <td><i class="fa fa-check checkmark"></i></td>
        <td><i class="fa fa-ban cross"></i></td>
        <td><i class="fa fa-ban cross"></i></td>
      </tr>
    </tbody>
  </table>
  <div class="smallspacer"></div>

  <h4 class="mark">Array</h4>
  <div class="info">
    Use an array when you need:
    <ul>
      <li>A list of elements of which the <b>order is important</b></li>
      <li>Access to elements by their <b>position</b> (index)</li>
      <li>The possibility to store <b>duplicates</b></li>
    </ul>
  </div>

  <pre><code class="language-javascript">
        // In this example the order of elements is important
        const tasks = ['Wake up', 'Brush teeth', 'Have breakfast'];

        for (const task of tasks) {
          console.log(task);
        } 
        // Output: 'Wake up', 'Brush teeth', 'Have breakfast'

        console.log(tasks[0]); 
        // Output: 'Wake up'

        // Why not object: we don't need named keys, just a list in a fixed order
        // Why not map: we don't need key-value pairs, the index is enough
        // Why not set: we might need duplicates
  </code></pre>
  
  <h4>Object</h4>
  <div class="info">
    Use an object when you need:
    <ul>
      <li>Key-value pairs of which the keys are strings or symbols</li>
      <li>Quick access through <b>unique keys</b></li>
      <li>Simple syntax and direct JSON support</li>
    </ul>
  </div>
  <pre><code class="language-javascript">
        // In this example we need key-value pairs with quick access
        // We want simple actions to add or change values

        const person = {
          name: 'John Doe',
          age: 30,
          occupation: 'Tester'
        };

        person.location = 'New York';

        for (const [key, value] of Object.entries(person)) {
          console.log(&#096;&#036;{key}: &#036;{value}&#096;);
        }
        // Output:
        // name: John Doe
        // age: 30
        // occupation: Tester
        // location: New York

        // Why not array: we need named keys instead of positions
        // Why not map: we want simple access (obj.key vs map.get(key)) and JSON support
        // Why not set: a set stores only values, not key-value pairs
  </code></pre>

  <h4>Map</h4>
  <div class="info">
    Use a map when you need:
    <ul>
      <li>A <b>dynamic collection</b> of key-value pairs: the keys often come from your data at runtime</li>
      <li>Frequent adding, looking up and removing of entries (<code>set</code>, <code>get</code>, <code>has</code>, <code>delete</code>)</li>
      <li>Keys that keep their datatype (numbers, objects, ..) and a guaranteed insertion order</li>
      <li>Easy access to the number of entries (<code>map.size</code>)</li>
    </ul>
    Rule of thumb: an object fits a fixed structure with known properties (like a person),
    a map fits a collection of entries that you add, look up and remove.
  </div>
  <pre><code class="language-javascript">
        // In this example the keys (brands) are only known at runtime
        // and we count how often each brand appears

        const sales = ['Casio', 'Seiko', 'Casio', 'Tissot', 'Casio'];
        const brandCount = new Map();

        for (const brand of sales) {
          brandCount.set(brand, (brandCount.get(brand) || 0) + 1);
        }

        console.log(brandCount);
        // Output: Map(3) { 'Casio' => 3, 'Seiko' => 1, 'Tissot' => 1 }

        console.log(brandCount.get('Casio'));
        // Output: 3

        console.log(brandCount.size);
        // Output: 3

        for (const [brand, count] of brandCount) {
          console.log(&#096;&#036;{brand}: &#036;{count}&#096;);
        }
        // Output:
        // Casio: 3
        // Seiko: 1
        // Tissot: 1

        // Why not object: an object is meant for a fixed structure with known keys,
        //   it converts every key to a string and has no built-in size or direct iteration
        // Why not array: we need key-value pairs
        // Why not set: a set stores only values, not key-value pairs
  </code></pre>

  <h4>Set</h4>
  <div class="info">
    Use a set when you need:
    <ul>
      <li>A collection of <b>unique values</b></li>
      <li>A quick check whether a value exists (<code>set.has()</code>)</li>
    </ul>
  </div>
  <pre><code class="language-javascript">
        // In this example we need unique values

        const watchBrands = new Set();
        watchBrands.add('Casio');
        watchBrands.add('Seiko');
        watchBrands.add('Casio');

        console.log(watchBrands); 
        // Output: Set(2) { 'Casio', 'Seiko' }

        console.log(watchBrands.has('Seiko')); 
        // Output: true

        // Why not array: an array allows duplicates
        // Why not object or map: we only need values, not key-value pairs
  </code></pre>

  </div> 
</div> <!-- end data structures  -->


<!-- ARRAYS -->

<div data-id="javascript-arrays" class="level1-container"> 
  <h1>Arrays</h1>

    <div data-id="arrays-destructuring">
        <h2>Destructuring</h2>
          <pre><code class="language-javascript">
        // Destructure the first element of an array
        const numbers = [2, 3, 4];
        const [ foo ] = numbers; 
        console.log(foo); // Output: 2

        // Destructure the first two elements of an array
        const numbers = [2, 3, 4];
        const [ foo, bar ] = numbers;
        console.log(foo, bar); // Output: 2, 3

        // Destructure the first and third element of an array by skipping one
        const numbers = [2, 3, 4];
        const [ foo, , bar ] = numbers;
        console.log(foo, bar); // Output: 2, 4

        // Destructuring can mutate already existing variables
        const cookie = 5;
        const milk = 6;
        [ cookie, milk ] = numbers;
        console.log(cookie, milk); // Output: 2, 3

        // Destructuring nested arrays
        const nested = ['sparrow', ['starling', 'crow'], 'magpie', 'finch'];
        const [ bird1, [bird2, bird3], bird4] = nested;
        console.log(bird1, bird2, bird3, bird4); // Output: sparrow, starling, crow, magpie

        // Destructuring with default values
        // Useful when the amount of variables is more than the elements in the array
        const animals = ['cat', 'dog'];
        const [animal1='fish', animal2='turtle', animal3='bird'] = animals;
        console.log(animal1, animal2, animal3); // Output: cat, dog, bird
        </code></pre>
        
        <h3>Switching variable values using destructuring</h3>
        <pre><code class="language-javascript">
        // Switching values without destructuring requires a temporary variable
        const age1 = 20;
        const age2 = 30;

        const temp = age1;
        age1 = age2;
        age2 = temp;

        // Switching values by destructuring 
        const age1 = 20;
        const age2 = 30;

        [ age2, age1 ] = [ age1, age2 ];
        </code></pre>
      </div> <!-- end arrays destructuring -->


    <div data-id="arrays-non-mutating methods">
      <h2>Array manipulation: Non-mutating methods</h2>
      <div class="info">
      Non-mutating methods are methods that return a new array, object, or value.<br>
      They do not modify the original.
      </div>
      <h3>slice</h3>
      <div class="extra-info">Slice returns a subset of an array</div>
      <pre><code class="language-javascript">
        const letters = [ 'a', 'b', 'c', 'd' ];

        // From starting index (inc) until the end of the array
        const part = letters.slice(2);
        console.log(part); // Output: [b, c, d]

        // From starting index (inc) up to end index (exc)
        const part = letters.slice(2, 3);
        console.log(part); // Output: [c]

        // From the second te last element (inc) until the end of the array
        const part = letters.slice(-2);
        console.log(part); // Output: [c, d]

        // From the second element (inc) until the second to last element (exc)
        const part = letters.slice(1, -2);
        console.log(part); // Output: [b]

        // Creates a shallow copy of the array. Similar to [...letters]
        const part = letters.slice();
        console.log(part); // Output: [a, b, c, d]
      </code></pre>
      <h3>concat</h3>
      <div class="extra-info">Concat concatenates two arrays</div>
      <pre><code class="language-javascript">
        const firstLetters = [ 'a', 'b' ];
        const lastLetters = [ 'y', 'z' ];

        const newArray = firstLetters.concat(lastLetters); 
        // Same as const newArray = [ ...firstLetters, ...lastLetters ];
      </code></pre>
      <h3>join</h3>
      <div class="extra-info">Join creates a string from an array with a given delimiter</div>
      <pre><code class="language-javascript">
        const letters = [ 'c', 'a', 't' ];
        let letterString;

        // Default is space ' '
        letterString = letters.join();
        console.log(letterString); // Output: 'c a t'

        letterString = letters.join('');
        console.log(letterString); // Output: 'cat'

        letterString = letters.join('--');
        console.log(letterString); // Output: 'c--a--t' 
      </code></pre>
      <h3>toString</h3>
      <div class="extra-info">toString converts the array into a comma-separated string</div>
      <pre><code class="language-javascript">
        const letters = [ 'c', 'a', 't' ];

        const letterString = letters.toString();
        console.log(letterString); // Output: 'c,a,t'
      </code></pre>
    </div> <!-- end non-mutating methods -->
    
    <br><br><br>

    <div data-id="arrays-mutating methods">
      <h2>Array manipulation: Mutating methods</h2>
      <div class="info">
      Mutating methods are methods that do not return anything, instead they modify the original.<br>
      They are best avoided.
      </div>
      <h3>splice</h3>
      <div class="extra-info">Splice removes elements</div>
      <pre><code class="language-javascript">
        /* Accepts a startindex, a number (of elements),
        and any amount of new elements to be inserted */

        // Removes all elements starting from index 2 (inc)
        const letters = [ 'a', 'b', 'c' ];
        letters.splice(2);
        console.log(letters); // Output: ['a', 'b']

        // Removes 2 elements starting at index 1
        const letters = [ 'a', 'b', 'c' ];
        letters.splice(1, 2);
        console.log(letters); // Output: ['a']

        // Removes 2 elements starting at index 1, inserts 'd' at index 1
        const letters = [ 'a', 'b', 'c' ];
        letters.splice(1, 2, 'd');
        console.log(letters); // Outut: ['a', 'd']
      </code></pre>
      <h3>reverse</h3>
      <div class="extra-info">reverse reverses the array</div>
      <pre><code class="language-javascript">
        const letters = [ 'a', 'b', 'c' ];
        letters.reverse();
        console.log(letters); // Output: ['c', 'b', 'a']
      </code></pre>
      <h3>push</h3>
      <div class="extra-info">push adds an element to the end of an array</div>
      <pre><code class="language-javascript">
        const letters = [ 'a', 'b' ];
        letters.push('c');
        console.log(letters); // Output: ['a', 'b', 'c']
      </code></pre>
      <h3>pop</h3>
      <div class="extra-info">pop removes the last element of an array </div>
      <pre><code class="language-javascript">
        const letters = [ 'a', 'b', 'c' ];
        letters.pop();
        console.log(letters); // Output: ['a', 'b']
      </code></pre>
      <h3>shift</h3>
      <div class="extra-info">shift removes the first element of an array and returns it</div>
      <pre><code class="language-javascript">
        const letters = [ 'a', 'b', 'c' ];
        const firstLetter = letters.shift();
        console.log(firstLetter); // Output: 'a'
        console.log(letters); // Output: ['b', 'c']
      </code></pre>
      <h3>unshift</h3>
      <div class="extra-info">unshift adds elements to the beginning of an array</div>
      <pre><code class="language-javascript">
        const letters = [ 'c' ];
        letters.unshift('a', 'b');
        console.log(letters); // Output: ['a', 'b', 'c']
      </code></pre>
    </div><!-- end arrays mutating methods -->

      <br><br><br>

    <div data-id="arrays-searching and indexing">
      <h2>Searching, indexing and testing</h2>
      <h3>includes</h3>

      <pre><code class="language-javascript">
        const letters = [ 'a', 'b', 'c' ];
        const hasB = letters.contains('b');
        console.log(hasB); // Output: true
      </code></pre>
      <h3>some</h3>
      <div class="extra-info">some checks if at least 1 element matches the condition</div>
      <pre><code class="language-javascript">
        const numbers = [ -1, 0, 1];
        const hasPositive = numbers.some(number => number > 0);
        console.log(hasPositive); // Output: true
      </code></pre>
      <h3>every</h3>
      <div class="extra-info">every checks if all elements match the condition</div>
      <pre><code class="language-javascript">
        const numbers = [ -1, 0, 1];
        const arePositive = numbers.every(number => number > 0);
        console.log(arePositive); // Output: false
      </code></pre>
      <h3>indexOf</h3>
      <div class="extra-info">indexOf returns the first index of the given value</div>
      <pre><code class="language-javascript">
        const letters = [ 'b', 'a', 'b' ];
        const index = letters.indexOf('b');
        console.log(index); // Output: 0
      </code></pre>
      <h3>lastIndexOf</h3>
      <div class="extra-info">lastIndexOf returns the last index of the given value</div>
      <pre><code class="language-javascript">
        const letters = [ 'b', 'a', 'b' ];
        const index = letters.lastIndexOf('b');
        console.log(index); // Output: 2
      </code></pre>
      <h3>find</h3>
      <div class="extra-info">find returns the first element that meets the condition</div>
      <pre><code class="language-javascript">
        const letters = [ 'a', 'b', 'c' ];
        const found = letters.find(letter => letter === 'a')
        console.log(found); // Output: 'a'
      </code></pre>
      <h3>findIndex</h3>
      <div class="extra-info">findIndex returns the the index of the first element that meets the condition</div>
      <pre><code class="language-javascript">
        const letters = [ 'a', 'b', 'c' ];
        const index = letters.findIndex(letter => letter === 'a')
        console.log(index); // Output: 0
      </code></pre>
      <h3>at</h3>
      <div class="extra-info">at returns the element at the given index</div>
      <pre><code class="language-javascript">
        const letters = [ 'c', 'a', 't' ];

        const letter = letters.at(0);
        console.log(letter); // Output: 'c'

        const letter = letters.at(-1);
        console.log(letter); // Output: 't'
      </code></pre>
      <h3>Three ways of getting the last element of an array</h3>
      <pre><code class="language-javascript">
        const letters = [ 'a', 'b', 'c' ];

        // Standard bracket notation
        const lastElement = letters[letters.length -1];

        // Using slice()
        const lastElement = letters.slice(-1)[0];

        // Using at()
        const lastElement = letters.at(-1);
      </code></pre>
    </div> <!-- end arrays searching and indexing -->

      <br><br><br>

    <div data-id="arrays-aggregation methods">
      <h2>Aggregation methods</h2>
      <h3>map</h3>
      <div class="extra-info">map calls the provided cbfn for each element in the array</div>
      <pre><code class="language-javascript">
        // Map returns an array with the SAME amount of elements as the original

        const numbers = [ 2, 3, 4 ];

        const timesTwo = numbers.map(number => number * 2);
        console.log(timesTwo); 
        // Output: [4, 6, 8]

        // The cbfn is provided the element, index, and entire array
        const evenUneven = numbers.map((number, index, array) => {
          if (number % 2 === 0){
            console.log(&#96;Number &#36;{number} at index &#36;{index}
              from a total of &#36;{array.length} elements is even&#96;);
            return 'Even';
          }else{
            console.log(&#96;Number &#36;{number} at index &#36;{index}
              from a total of &#36;{array.length} elements is uneven&#96;);
            return 'Uneven'
          }
          console.log(indexesEvenNumbers);
        })
        // Output: 
        // Number 2 at index 0 from a total of 3 elements is even
        // Number 3 at index 1 from at total 3 elements is uneven
        // Number 4 at index 2 from a total of 3 elements is even
        // [ 'Even', 'Uneven', 'Even' ]


        /* The function below returns an array with people objects.
            It creates a property called initials from the person's name */
        const people = [ { name: 'Matthias Swerts', },
                          { name: 'Peter Pan', } ];

        const createInitials = (people) => {
          return people.map((person) => {
            ...person,
            initials: person.name.toLowerCase()
            .split(' ')
            .map(namePart => namePart[0])
            .join('');
          })
        }

        console.log(createInitials(people));
        // Output: 
        // [ { name: 'Matthias Swerts', initials: 'ms'},
        //   { name: 'Peter Pan', initials: 'pp'} ]
      </code></pre>

      <h3>filter</h3>
      <div class="extra-info">filter returns an array with elements that meet a condition</div>
      <pre><code class="language-javascript">
        // Filter usually returns an array with a smaller amount of elements than the original
        const numbers = [ -1, 0, 1 ];

        const filterResult = numbers.filter(nr => nr > 0);
        console.log(filterResult); // Output: [1]

        const filterResult2 = numbers.filter(() => { return true; })
        console.log(filterResult2); // Output: [-1, 0, 1];

        const filterResult2 = numbers.filter((nr, index, array) => {
          console.log(nr, index, array.length);
          return nr > 10;          
        });
        // Output: 
        // [-1, 0, 3]
        // [0, 1, 3]
        // [1, 2, 3]

        console.log(filterResult2); // Output: []
      </code></pre>
      
      <h3>reduce</h3>
      <div class="extra-info">reduce boils an arrow down to a single value</div>
      <pre><code class="language-javascript">
        /* Reduce returns a single value
        Reduce accepts a cbfn and a starting value for the accumulator
        It iterates over every element, changes and passed the accumulator
        The cbfn accepts the accumulator, the current element, the index 
        and the entire array
        The accumulator is returned through every iteration */

        const numbers = [ 1, 6, 2 ];
        const total = numbers.reduce((accumulator, currentElement) => {
          return accumulator + currentElement;
        }, 0); // Starting value of the accumulator is 0
        console.log(total); // Output: 9

        // Don't use 0 as starting value when calculating min or max!
        const max = numbers.reduce((acc, cur) => {
            return acc < cur ? cur : acc;
        }, numbers[0]); 
        console.log(max); // Output: 6

        const example = numbers.reduce((acc, cur) => acc++, 0);
        console.log(example);
        // Output: 0
        // This is because the increment on acc++
        // happens AFTER the return. Use ++acc instead

        // Reduce can use objects as an accumulator
        const numbers = [ -1, -4, 5, 0, 1 ];
        const { pos, neg } = numbers.reduce((acc, cur) => {
            acc[cur > 0 ? 'pos' : 'neg'] += cur;
            return acc;
        }, { pos: 0, neg: 0});
        console.log(pos, neg); // Output: -5, 6
      </code></pre>
      </div> <!-- end aggregation methods --> 

      <div data-id="arrays-flattening">
      <h2>Flattening</h2>
      <h3>flat</h3>
      <div class="extra-info">flat 'flattens' a nested array into a 1D array</div>
      <pre><code class="language-javascript">
        // The default level of flattening is 1
        // Meaning it will flatten 1 level of nested arrays
        const numbers = [ 3, [ -1, 5 ], 2 ];
        const flatNumbers = numbers.flat();
        console.log(flatNumbers); // Output: [3, -1, 5, 2]

        // In case of multiple levels of nesting
        // The depth of the flattening can be specified
        const numbers = [ 3, [ -1, [5, 9] ], 2 ];
        const flatNumbers2 = numbers.flat(2);
        console.log(flatNumbers1); // Output: [3, -1, 5, 9, 2];
      </code></pre>

      <h3>flatMap</h3>
      <div class="extra-info">flatMap flattens an array 1 level and executes a map cbfn on it</div>
      <pre><code class="language-javascript">
        /* A common practice is using map to retrieve an array from a bunch of objects 
        by putting them into a single array using map() */
        const nrObjects = [ { nrs: [1, 2] }, { nrs: [3, 4, 6] }, { nrs: [9] } ];
        const singleArray = nrObjects.map(nrObj => nrObj.nrs)
        console.log(singleArray); // Output: [ [1,2], [3,4,6], [9] ];

        // As you can see, the result is usually a nested array
        // that needs to be flattened
        const flatArray = singleArray.flat();
        console.log(flatArray); // Output: [1,2,3,4,6,9];

        // Since this happens so often, flatMap() was invented
        // which does nothing more than map() followed by flat() in one method
        const flatMappedArray = nrObjects.flatMap(nrObj => nrObj.nrs);
        console.log(flatMappedArray); // Output: [1,2,3,4,6,9]

        // Note that flatMap() only flattens 1 level.
        // In case of deeper nesting .map().flat() is still needed
      </code></pre>
    </div> <!-- end array flattening -->

    <div data-id="arrays-sorting">
      <h2>Sorting</h2>
      <div class="info">Be aware that .sort() mutates the original array. Best use ... or .slice() to make a copy before sorting.
      </div>
      <h3>sort</h3>
      <div class="extra-info">sort sorts strings alphabetically</div>
      <pre><code class="language-javascript">
        // Sort() without a cbfn only works on strings
        const letters = [ 'b', 'a', 'c' ];
        letters.sort();
        console.log(letters); // Output: ['a','b','c']

        // Best used with a copy
        const letters = [ 'b', 'a', 'c' ];
        const sortedLetters = [...letters].sort();
        console.log(letters, sortedLetters); 
        // Output: ['b','a','c'] ['a','b','c']

        // When used on numbers, they too will be sorted alphabetically
        const numbers = [ 20, -1, 3, 1300 ];
        const sortedNumbers = [...numbers].sort();
        console.log(sortedNumbers); // Output: [-1, 1300, 20, 3]
      </code></pre>
      <h3>sort with a callbackfunction</h3>
      <div class="extra-info">sort with a callbackfunction can sort numbers</div>
      <pre><code class="language-javascript">
        /* The sort cbfn accepts the current and next element.
        If the return value is > 0, the values will be swapped
        If the return value is <= 0, nothing will happen */

        // This will sort ascending.
        // You can sort descending by swapping the return values around.
        const numbers = [ 2, -1, 9 ];
        const sortedNumbers = [...numbers].sort((cur, next) => {
          if (cur > next) return 1;
          if (cur <= next) return -1;
        });
        console.log(sortedNumbers); // Output: [-1,2,9]

        // We can simplify the code by assuming:
        // If a < b then a-b would be < 0
        // If a > b then a-b would be > 0
        // So we can rewrite it like this:
        const sortedNumbers2 = [...numbers].sort((cur, next) => cur - next)
        console.log(sortedNumbers2); // Output: [-1,2,9]

        // a-b sorts ascending, b-a sorts descending
      </code></pre>
    </div> <!-- end array sorting -->

    <div data-id="arrays-advanced array creation">
      <h2>Advanced array creation</h2>
      <h3>new Array()</h3>
      <div class="extra-info">new Array() creates an empty array</div>
      <pre><code class="language-javascript">
        /* new Array() accepts the length of the array to be created.
        Can be used to create an array of a predefined or dynamic length 
        but no initial values */
        const emptyArray = new Array(3);
        console.log(emptyArray); // Output: [emptyx3]
      </code></pre>
      <h3>Mutating the length of an array</h3>
      <pre><code class="language-javascript">
        // An array can be extended or shortened by setting the length property
        const emptyArray = [];
        emptyArray.length = 3;
        console.log(emptyArray); // Output: [emptyx3];

        const fullArray = [ 1, 2 ];
        fullArray.length = 4;
        console.log(fullArray); // Output: [1,2,emptyx2]

        fullArray.length = 1;
        console.log(fullArray); // Output: [1];
      </code></pre>
      <h3>fill</h3>
      <div class="extra-info">fill fills an array with a given value</div>
      <pre><code class="language-javascript">
        // fill accepts a value, a startindex and an endindex
        const emptyArray = new Array(3);
        emptyArray.fill(1);
        console.log(emptyArray); // Output: [1,1,1];

        // Value and startindex (inc)
        const numbers = [ 1, 2, 3 ];
        numbers.fill('a', 1);
        console.log(numbers); // Output: [1,'a','a']

        // Value, startindex (inc) and endindex (exc)
        const numbers2 = [ 1, 2, 3, 4 ];
        numbers2.fill('a', 1, 3);
        console.log(numbers2); // Output: [1,'a','a',4]
      </code></pre>
      <h3>Array.from</h3>
      <div class="extra-info">Array.from creates an array from an iterable or array-like object</div>
      <pre><code class="language-javascript">
        /* 'Array.from' creates a shallow-copy.
        It accepts an iterable and a cbfn that works the same as 'map'.
        'from' works the same as using the spread operator, but with a built in mapping cbfn */
        
        const array1 = Array.from('foo');
        console.log(array1); // Output: ['f','o','o']
        // Same as const array1 = [...'foo'];

        const array2 = Array.from([1, 2, 3], x => x+x);
        console.log(array2); // Output: [2,4,6]

        const array3 = Array.from(
          document.querySelectorAll('.classname'), 
          (el, i, theArray) => Number(el.textContent.replace('€', '')) 
        );
      </code></pre>
    </div> <!-- end array advanced -->
</div> <!-- end arrays -->

<div data-id="javascript-objects" class="level1-container"> 
  <h1>Objects</h1>
    <div data-id="objects-accessing properties">
    <h2>Accessing properties</h2>
    <pre><code class="language-javascript">
        const person = { name: 'Matthias', birthYear: 1990 };
        console.log(person['name']); // Output: 'Matthias'
        console.log(person.name); // Output: 'Matthias'

        // Keys can be variables
        const propertyName = 'name';
        console.log(person[propertyName]); // Output: 'Matthias'

        // Accessing nested object properties
        const phone = {
          brand: 'Samsung',
          dimensions: {
            height: 20,
            width: 12,
          }
        };

        console.log(phone.dimensions.height); // Output: 20
        console.log(phone['dimensions']['height']); // Output: 20

        // Keys can be variables when placed between square brackets []
        const weekdays = [ 'mon', 'tue', 'wed' ];
        const openinghours = 
        {
          [weekdays[0]]: {
            open: 9,
            close: 12,
          },
          [weekdays[1]]: {
            open: 12,
            close: 16,
          },
        };

        console.log(openinghours.mon.open);

        // A method is just a property whose value is a function, so it can be
        // called through bracket notation exactly like any other property is accessed:
        const speaker = { name: 'Matthias', greet() { return &#096;Hi, I'm &#036;{speaker.name}&#096;; } };

        speaker.greet();          // "Hi, I'm Matthias"
        speaker['greet']();       // same, via bracket notation

        // This becomes essential (not just a style choice) once the key is computed:
        const methodName = 'greet';
        speaker.methodName();     // TypeError: methodName is not a function -> dot notation looks for the LITERAL name "methodName"
        speaker[methodName]();    // "Hi, I'm Matthias" -> brackets evaluate the variable first, then call the result
    </code></pre>
    </div>
    <div data-id="objects-destructuring">
    <h2>Destructuring</h2>
        <pre><code class="language-javascript">
          // Destructuring into variables
          const person = { name: 'Matthias', birthYear: 1990, };
          const { name, birthYear } = person;
          console.log(name, birthYear); // Output: Matthias, 1990

          // Destructuring and providing new variable names
          const { name: personName, birthYear: bYear } = person;
          console.log(personName, bYear); // Output: Matthias, 1990

          // Destructuring with default values
          const { theName = 'Peter', theYear = 2000, country = 'Belgium' } = person;
          console.log(theName, theYear, country); 
          // Output: 'Matthias', 1990, 'Belgium'

          /* Destructuring can mutate already existing variables
          This requires parentheses to tell JS that the destructuring is
          an expression and not a block */
          const car = { brand: 'VW', type: 'Golf' };
          let brand = 'BMW';
          let type = '1 series';
          ({ brand, type } = car); // Notice the brackets
          console.log(brand, type); // 'VW', 'Golf'

          // Destructuring nested objects
          const forecast = {
            type: 'rain',
            time: {
              start: 16,
              end: 17,
            },
          };

          // Be aware when destructuring nested objects
          // that only the lowest stated levels are destructured!
          const { time: { start: beginHour, end: endHour } } = forecast
          console.log(time); // Output: ReferenceError: time is not defined
          console.log(beginHour, endHour); // Output: 16, 17

          // Higher levels can be destructured as well by stating them 
          const { time, time: { start, end} } = forecast;
          console.log(time); // Output { start: 16, end: 17 };

          // Another example of deeply nested destructuring
          const book = {
            ratings: {
              goodreads: {
                rating: 1,
              }
            }
          };

          // Destructuring first level
          const { ratings } = book; 
          console.log(ratings); // Output: {goodreads: {rating: 1}}

          // Destructuring second level
          const { ratings: { goodreads } } = book;
          console.log(goodreads); // Output: {rating: 1}

          // Destructuring third level
          const { ratings: { goodreads: { rating } } } = book;
          console.log(rating); // Output: 1

          // Destructuring can be done for objects in function arguments
          myBook = {
            title: 'Well of darkness',
            rating: 7,
            isbn: 12345,
        };

        let rateBook = function ({ title, rating, isbn}){
          console.log(title, rating, isbn); 
        }
        rateBook(myBook); // Output: 'Well of darkness', 7, 12345
          
        // Destructuring in function arguments with default values
        rateBook = function ({ title='no title', rating, isbn, pages=100}){
          console.log(title, rating, isbn, pages); 
        }
        rateBook(myBook); // Output: 'Well of darkness', 7, 12345, 100

        // Destructuring in function arguments with aliasing and default values
        rateBook = function ({ title: bookTitle='no title', rating: bookRating=0,
            isbn: code, pages: nrPages=100 }){
          console.log(bookTitle, bookRating, code, nrPages); 
        }
        rateBook(myBook); // Output: 'Well of darkness', 7, 12345, 100
      </code></pre>
  </div><!-- end object destructuring -->
  
  <div data-id="objects-looping over objects">
  <h2>Looping over objects</h2>
      <pre><code class="language-javascript">
        const watches = {
          seiko: {
            price: 500,
            type: 'mechanical',
          },
          casio: {
            price: 50,
            type: 'digital',
          },
        };

        // You can iterate over objects by retrieving the keys, values or entries

        // Object.keys() returns an array of the keys
        const keys = Object.keys(watches);
        for (const key of keys){
          console.log(key); 
        }
        // Output: 
        // 'seiko'
        // 'casio'

        // Object.values() returns an array of the values
        const values = Object.values(watches);
        for (const value of values){
          console.log(value); 
        }
        // Output: 
        // {price: 500, type: 'mechanical'}
        // {price: 50, type: 'digital'}

        // When the values are objects, you can destructure them immediately
        for (const { price, type } of values){
          console.log(price, type); 
        }
        // Output:
        // 500, 'mechanical'
        // 50, 'digital'

        // Object.entries() returns an array with an array with a key and value
        const entries = Object.entries(watches);
        for (const entry of entries){
          console.log(entry); 
        }
        // Output: 
        // ['seiko', {price:500,type:'mechanical'}]
        // ['casio', {price:50,type:'digital'}]

        // Again, you can destructure arrays and objects immediately
        for (const [ key, { price, type } ]){
          console.log(key, price, type);
        }
        // Output:
        // 'seiko', 500, 'mechanical'
        // 'casio', 50, 'digital'
      </code></pre>
  </div> <!-- end object looping -->

  <div data-id="objects-cloning and freezing">
    <h2>Cloning and freezing</h2>
    <h3>Cloning</h3>
    <div class="info">
    Because objects are reference values, they can't be copied.<br>
    The copy will refer to the same memory instance as the original.<br>
    Keep in mind that a clones are shallow, only the first level is cloned.<br>
    Deeper nested objects (eg. arrays, sets, maps, ..) will still have their value by reference of the original
    </div>
        <pre><code class="language-javascript">
        // Cloning an object shallow using Object.assign() on an empty object
        const watch = { brand: 'seiko', type: 'mechanical' };
        const clonedWatch = Object.assign({}, watch);

        // Using the spread operator does the exact same thing and is shorter
        const clonedWatch2 = { ...watch };

        // Using the spread operator you can add and change values on objects easily
        // If properties are duplicated, the last property in the order overwrites earlier ones
        const watch = { brand: 'Casio', price: 50 };
        const clonedWatch = { ...watch, price: 44, type: 'digital' };
        console.log(clonedWatch); 
        // Output: {brand:'Casio',price:44,type:'digital'}
        </code></pre>
    <h3>Freezing</h3>
    <div class="info">
    Objects can be made immutable by freezing them using Object.freeze().<br>
    This prevents any properties from being added or changed.<br>
    Be aware that this is a shallow freeze. Only the first level is frozen.<br>
    Third-party libraries can be used to perform deepfreezes if necessary.
    </div>
      <pre><code class="language-javascript">
        // Adaptations to a frozen object will be ignored
        const watch = { brand: 'seiko', type: 'mechanical' };
        const frozenWatch = Object.freeze(watch);
        frozenWatch.brand = 'casio'; 
        frozenWatch.price = 500;
        console.log(frozenWatch);
        // Output: {brand: 'seiko', type: 'mechanical'}
      </code></pre>
  </div><!-- end object cloning and freezing -->
  <div data-id="objects-enhanced object literals">
  <h2>Enhanced object literals</h2>
  <div class="info">
    An object can be easily added to another object
  </div>
    <pre><code class="language-javascript">
        const book = {
          title: 'lotr',
        };

        // old way:
        const ratedBook = {
          rating: 10,
          book: book,
        };

        // Current way:
        const ratedBook = {
          rating: 10,
          book
        };

        console.log(ratedBook); 
        /// Output: 
        // { rating: 10, book: { title: 'lotr' } }
    </code></pre>
    <div class="info">
    A function can be declared inside an object
    </div>
    <pre><code class="language-javascript">
        // Old way
        const watch = {
          setTime: function(){ return 'set' },
        }

        // Current way
        const watch = {
          setTime(){return 'set'},
        }
    </code></pre>
  </div><!-- end enhanced object literals -->
  <div data-id="objects-getters and setters">
  <h2>Getters and Setters</h2>
  <div class="info">
    Getters and setters can be defined on objects and classes.<br>
    They are called as if they were regular properties, without parentheses.
  </div>
  <pre><code class="language-javascript">
        const person = {
          _firstName: "Matthias", // _ indicates internal storage only
          _lastName: "Swerts",

          // Getter to retrieve the full name
          get fullName() {
            return &#096;&#036;{this._firstName} &#036;{this._lastName}&#096;;
          },

          // Setter to update both first and last name
          set fullName(name) {
            [this._firstName, this._lastName] = name.split(" ");
          },
        };

        console.log(person.fullName); // Output: Matthias Swerts
        person.fullName = "Jane Smith"; // Update the full name
        console.log(person.fullName); // Output: Jane Smith
  </code></pre>
  </div><!-- end object getters and setters -->
</div><!-- end objects -->


<div data-id="javascript-maps" class="level1-container"> 
  <h1>Maps</h1>
  <h2>Usage</h2>
  <div data-id="maps-usage">
    <pre><code class="language-javascript">
        const watch = new Map();
        watch.set('brand', 'Seiko');

        // .set returns the map itself, so you can chain from set
        watch
          .set('price', 500)
          .set('type', 'mechanical');

        // A map can be set on declaration by passing an array of arrays.
        // The subarrays should be the key-value pairs
        const example = 
            new Map([
              ['key1', 'value1'],
              ['key2', 'value2']
            ])

        // Retrieve a value from a key using .get
        const brand = watch.get('brand');
        console.log(brand); // Output: 'Seiko'

        // Check if a key is present using .has
        const hasType = watch.has('movement');
        console.log(hasType); // Output: false

        // Delete an entry using .delete. It returns 1 for succes, 0 for fail
        const isDeleted = watch.delete('type');
        console.log(watch, isdeleted); 
        // Outpout: {'brand'=>'Seiko','price'=>500}, true

        // Retrieve the size using .size
        const mapSize = watch.size;
        console.log(mapSize); // Output: 2

        // Clear the entire map
        watch.clear();
        console.log(watch); // Output: Map{}

        // Maps can use anything as a key
        const watchObj = { brand: 'Casio', price: 50 };
        const watchMap = new Map();
        watchMap.set(watchObj, 'sold');
        console.log(watchMap.get(watchObj)); // Output: 'sold'

        /* Keep in mind that the objects (and arrays, etc) are reference values.
        The following code will not work because the memory addresses
        are different */
        watchMap.set({ brand: 'Casio' }, 'sold');
        watchMap.get({ brand: 'Casio' }); // Output: undefined

        // It is even possible to use DOM elements as keys
        watch.set(document.querySelector('.watches'), 'watchContainerElement');
    </code></pre>
    </div>

    <h2>Looping over maps</h2>
    <div data-id="maps-looping over maps">
    <pre><code class="language-javascript">
        // Using for..of on the map itself    
        const watches = new Map([['brand', 'seiko'], ['price', 500]]);
        for (const [key, value] of watches.entries()) {
          console.log(&#096;&#036;{key}: &#036;{value}&#096;);
        }
        // Output: 
        // brand: seiko
        // price: 500

        // The default map iterator is equivalent to .entries()
        // It gives key-value pairs, so the .entries() is optional
        for (const [key, value] of watches) {
          console.log(&#096;&#036;{key}: &#036;{value}&#096;);
        }
    </code></pre>
    </div>

    <h2>Converting maps</h2>
    <div data-id="maps-converting">
    <pre><code class="language-javascript">
        // An object can be converted to a map simply because Object.entries() 
        // returns an array of arrays that hold key-value pairs
        // just what a map is
        const watchObj = { brand: 'seiko', price: 500 };
        const watch = new Map(Object.entries(watchObj));

        // A map can be converted to an array using the spread operator
        const watchArray1 = [...watch]; 
        const watchArray2 = [...watch.entries()]; 

        // Both do the same since map returns key-value pairs by default
        console.log(watchArray1);
        // Output: [['brand', 'seiko'], ['price', 500]]

        console.log(watchArray2);
        // Output: [['brand', 'seiko'], ['price', 500]]
    </code></pre>
    </div><!-- end converting -->
</div><!-- end maps -->


<div data-id="javascript-sets" class="level1-container"> 
  <h1>Sets</h1>
  <h2>Usage</h2>
  <div data-id="sets-usage">
    <pre><code class="language-javascript">
        const uniqueWatches = new Set();
        uniqueWatches.add('Seiko');
        uniqueWatches.add('Casio');
        uniqueWatches.add('Seiko');
        console.log(uniqueWatches); // Output: {'Seiko','Casio'}

        // The constructor accepts any iterable 
        const watches = [ 'Casio', 'Casio', 'Seiko'];
        const uniqueWatches2 = new Set(watches);
        console.log(uniqueWatches2); // Output: {'Casio','Seiko'}
        const setSize = uniqueWatches2.size;
        console.log(setSize); // Output: 2

        const hasCasio = uniqueWatches.has('Casio');
        console.log(hasCasio); // Output: true

        uniqueWatches.delete('Seiko');
        console.log(uniqueWatches); // Output: {'Casio'}

        uniqueWatches.clear();
        console.log(uniqueWatches); // Output: Set{}

        // Beware that arrays are reference types
        // Even if they look the same, the memory object is different
        const nestedSet = new Set( [[ 1, 2 ], [ 1, 2 ]] );
        console.log(nestedSet); // Output: {[1,2],[1,2]}
    </code></pre>
  </div>
  
  <h2>Looping over sets</h2>
  <div data-id="sets-looping over sets">
  <pre><code class="language-javascript">
        const watches = new Set(['Casio', 'Seiko', 'Garmin']);
        for (const watch of watches){
          console.log(watch);
        }
        // Output: Casio Seiko Garmin
  </code></pre>
  </div>

  <h2>Converting sets</h2>
  <div data-id="sets-converting">
  <div class="info">
  Sets are often used to remove duplicates from arrays
  </div>
  <pre><code class="language-javascript">
        // Converting an array into a set and back into an array with unique values
        const watches = ['Casio', 'Casio', 'Seiko'];
        const uniqueWatches = [...new Set(watches)];
        console.log(uniqueWatches); // Output: ['Casio','Seiko']

        /* Converting a string to a set and back into a string with unique values.
        This creates a set from the string, then creates an array from the set,
        then joins the array into a string */
        const watch = 'Apple';
        const uniqueChars = [...new Set(watch)].join('');
        console.log(uniqueChars); // Output: 'Aple'
  </code></pre>
  </div>
</div><!-- end Sets -->

<div data-id="javascript-operators" class="level1-container"> 
  <h1>Operators</h1>
  <h2>Spread and rest operator</h2>
  <div data-id="operators-spread and rest operator">
  <div class="info">
  <ul>
  <li>The spread operator unpacks, and is used where values would be separated by commas</li>
  <li>The rest operator collects, and is used where variables would be separated by comma's</li>
  </ul>
  </div>
  <h3>Spread operator</h3>
  <div class="info">
  <ul>
  <li>The spread operator unpacks the individual values of an iterable</li>
  <li>It is used to build new arrays or pass values to a function</li>
  <li>The spread operator is always on the <b>right</b> side of an expression, <br>unlike the rest operator which is always on the <b>left</b> side of an expression</li>
  </ul>
  </div>
    <pre><code class="language-javascript">
        const numbers = [ 1, 2, 3 ];

        // Adding new values to an array
        const moreNumbers = [ -1, 0, ...numbers ];
        console.log(moreNumbers); // Output: [-1, 0, 1, 2 ,3]

        // Copy an array
        const numbersToo = [ ...numbers ]; 
        console.log(numbersToo); // Output: [1,2,3]

        // Join two or more arrays
        const evenMoreNumbers = [ ...numbers, ...numbersToo ];
        console.log(evenMoreNumbers); [1,2,3,1,2,3]

        // Split a string into an array
        const word = 'pen';
        const wordArray = [ ...word];
        console.log(wordArray); // Output: ['p','e','n']

        // Cloning objects (shallow)
        const watch = { brand: 'Casio', price: 50 };
        const clonedWatch = { ...watch, price: 44, type: 'digital' };
        console.log(clonedWatch); 
        // Output: {brand:'Casio, price:44, type:'digital'}

        // Passing separate array elements into a function
        const ingredients = [ 'cheese', 'sauce', 'olives' ];
        const createMargarita = function (ingr1, ingr2){
          console.log(&#096;Pizza with &#036;{ingr1} and &#036;{ingr2} is ready!&#096;);
        }
        createMargarita(...ingredients);
        // Output: Pizza with cheese and sauce is ready!

        // Trying to unpack an object into an array will give an error
        // This is because spread on an object copies its key-value pairs
        // it does not expand its elements into individual values
        const watchArray = [ ...watch ]; // Output: not iterable error
    </code></pre>
  </div>
  <h3>Rest operator</h3>
  <div class="info">
  <ul>
  <li>The rest operator collects values into a single variable</li>
  <li>It is primarily used in destructuring and function parameters</li>
  <li>The rest operator is always on the <b>left</b> side of an expression, <br>unlike the spread operator which is always on the <b>right</b> side of an expression</li>
  </ul>
  </div>
  <h4>Rest for destructuring</h4>
    <pre><code class="language-javascript">
        /* Use rest when destructuring an array to
        put the non-destructured part in a variable.
        It collects the "rest" in an array variable */

        const numbers = [ 1, 2, 3, 4, 5 ];
        let [ nrOne, nrTwo, ...others ] = numbers;
        console.log(others);
        // Output: [3,4,5]

        // Skipping an element during destructuring 
        [ nrOne, , nrThree, ...others ] = numbers;
        console.log(others); // Output: [4,5]
    </code></pre>
  <h4>Rest for function parameters</h4>
  <pre><code class="language-javascript">
        /* The rest operator as a function parameter will accept any number
          of parameters given to the function and store them in an array */

        const add = function (...numbers){
          return numbers.reduce((acc, nr) => acc += nr, 0);
        }

        console.log(add(1, 2, 3));
        // Output: 6

        /* Arrays can be passed as separate values using spread 
        to a function with a rest parameter */

        const nrArray = [ 1, 2, 3 ];
        console.log(add(...nrArray));
        // Output: 6

        /* A function's rest parameter can be used
        to catch any extra (or obsolete) arguments */

        const sumOfFirstTwoNumbers = function (firstNr, secondNr, ...extraNrs){
          return firstNr + secondNr;
        }

        console.log(sumOfFirstTwoNumbers(...nrArray));
        // Output: 3
  </code></pre>
  <h2>Short circuiting</h2>
  <div data-id="operators-short circuiting">
    <h3>OR-short circuit</h3>
    <div class="info">
    <ul><li>|| will return the first truthy value</li>
    <li>If no values are truthy, it returns the last value</li>
    <li>|| is suitable if you want to execute a fallback action only if the first operand is <b>falsy</b><br>
    Keep in mind this includes 0, '', negative numbers</li>
    <li>For fallback on <b>nullish</b> operands instead of falsy, use the nullish coalescing operator</li>
    </ul></div>
    <pre><code class="language-javascript">
        // Examples of || operator behavior
        const firstTruthy1 = 3 || 'Kebab'; 
        console.log(firstTruthy1); // Output: 3

        console.log('' || 'Kebab'); // Output: 'Kebab'
        console.log(true || 0); // Output: true
        console.log(undefined || null); // Output: null because it's the last value

        /* Beware using || for setting default variable values
        that can have faulty values that are considered acceptable (eg. 0 and '') */

        // Here we use || to check for undefined or null
        // However this creates a bug when people order 0 kebabs
        const passengers = passengerCount => {
          const totalPassengers = passengerCount || 1;
          console.log(&#096;You ordered &#036;{totalPassengers}&#096;);
        }
        passengers(4); // Output: 4
        passengers(null); // Output: 1
        passengers(undefined); // Output: 1
        passengers(''); // Output: 1

        // This might cause issues when there actually are no passengers
        passengers(0);// Output: 0 

        /* The || operator can sometimes replace simple if-statements,
          but may make the code harder to read.*/

        let username = ''; 

        // With if-statement
        if (!username) username = 'Guest';
        console.log(username); // Output: 'Guest'

        // With OR-short circuit
        username = username || 'Guest';
        console.log(username); // Output: 'Guest'
    </code></pre>

    <h3>AND-short circuit</h3>
    <div class="info"><ul><li>&& will return the first falsy value</li>
    <li>If no values are false, && returns the last value</li>
    <li>&& is suitable for conditional execution, but not for setting defaults<br>
    This is because it does not replace falsy values with the right hand side value like || does</li></ul></div>
    <pre><code class="language-javascript">
        // Examples of && operator behavior
        console.log(0 && 'Matthias'); // Output: 0
        console.log(7 && 'Matthias'); // Output: 'Matthias'
        console.log('Hello' && null && 'Matthias'); // Output: null
        console.log('Hello' && 'Matthias'); // Output: 'Matthias'

        /* The && operator can sometimes replace simple if-statements,
        but may make the code harder to read.*/

        // Using if
        const isLoggedIn = true;
        if (isLoggedIn) console.log('Welcome back!'); // Output: Welcome back!

        // Using &&
        isLoggedIn && console.log('Welcome back!'); // Output: Welcome back!
    </code></pre>

    <h3>Nullish coalescing operator</h3>
    <div class="info"><ul><li>?? will return the first non-nullish value</li>
    <li>Can be used to assign default variable values<br>
    This is because it does not replace falsy values with the right hand side value like || does</li></ul></div>
    <pre><code class="language-javascript">
        // ?? can be used as fallback on nullish operands
        // Unlike || which fallbacks on all falsy operands

        const passengers = passengerCount => {
          const totalPassengers = passengerCount ?? 1;
          console.log(&#096;You ordered &#036;{totalPassengers}&#096;);
        }

        passengers(4); // Output: 4
        passengers(null); // Output: 1
        passengers(undefined); // Output: 1
        passengers(''); // Output: 1
        passengers(0); // Output: 0
    </code></pre>
  </div><!-- end short circuiting -->
  <div data-id="operators-logical assignment operators">
  <h2>Logical assignment operators</h2>
  <div class="info">
  Logical assignment operators are used to combine logical operations with assignment<br>
  They <b>reassign</b> the variable so you will need to use <i>let</i><br><br>
  A useful mnemonic is:
  <ul><li>||= 'OR else assign it'</li>
  <li>&&= 'AND then update it'</li></ul>
  </div>
  <table>
    <thead>
        <tr>
            <th>Scenario</th>
            <th>Use This Operator</th>
        </tr>
    </thead>
    <tbody>
        <tr>
            <td>Need to set a fallback for falsy values</td>
            <td>||=</td>
        </tr>
        <tr>
            <td>Need to update a value only if it’s already valid</td>
            <td>&&=</td>
        </tr>
        <tr>
            <td>Need to set a value for null/undefined only</td>
            <td>??=</td>
        </tr>
    </tbody>
</table>

  <h3>OR logical assignment operator</h3>
  <div class="info">
    <ul>
    <li>||= assigns a value to a variable if the variable is falsy<br>
    Eg. if the variable is null, undefined, 0, '', ... </li>
    <li>Keep in mind that if any of the falsy values should be considered valid,
    you should probably use ??= instead</li>
    </ul>
  </div>
  <pre><code class="language-javascript">
        // Without ||= logical assignment operator
        let login = null;
        if (!login) login = "Default";
        console.log(login); // Output: Default

        // With logical ||= assignment operator
        login = null;
        login ||= "Default";
        console.log(login); // Output: Default

        login = "Matthias";
        login ||= "Default";
        console.log(login); // Output: Matthias

        let stockLevel = 0;
        stockLevel ||= 10;
        console.log(stockLevel); // Output: 10
        // This behaviour might be unexpected if 0 is a valid stocklevel
    </code></pre>
    <h3>AND logical assignment operator</h3>
    <div class="info">
      <ul>
      <li>&&= assigns a value to a variable if the variable is truthy</li>
      <li>Keep in mind that if any of the falsy values should be considered valid,
      you should probably use ??= instead</li>
      </ul>
    </div>
    <pre><code class="language-javascript">
        /* &&= assigns a value to a variable if the variable is truthy */

        // Without logical &&= assignment operator
        let nrPassengers = 1;
        if (nrPassengers) nrPassengers = "At least one passenger";
        console.log(nrPassengers); // Output: At least one passenger

        // With logical &&= assignment operator
        nrPassengers = 1;
        nrPassengers &&= "At least one passenger";
        console.log(nrPassengers); // Output: At least one passenger

        nrPassengers = 0;
        nrPassengers &&= "At least one passenger";
        console.log(nrPassengers); // Output: 0
  </code></pre>
  <h3>NULLISH logical assignment operator</h3>
  <div class="info">
    ??= assigns a value to a variable if the variable is null or undefined
  </div>
  <pre><code class="language-javascript">
        // Without ??=
        let userScore = 0; 
        if (userScore === null || userScore === undefined) {
            userScore = 10; 
        }
        console.log(userScore); // Output: 0 

        // Example with ??=
        let userScore = 0; 
        userScore ??= 10; 
        console.log(userScore);  // Output: 0

        let userLevel = null; 
        userLevel ??= 1; 
        console.log(userLevel); // Output: 1

        let userProgress; // Default is undefined
        userProgress ??= "Not started"; 
        console.log(userProgress); // Output: Not started
  </code></pre>
  </div>
  <div data-id="operators-optional chaining">
  <h2>Optional chaining</h2>
    <div class="info">
    <ul>
    <li>
    Optional chaining is used to safely access a property, method or array value that might not exist</li>
    <li>It returns 'undefined' instead of throwing a Uncaught TypeError</li>
    <li>
    It is often used in conjuction with the nullish coalescing operator (??) to handle the 'undefined' value that is returned</li>
    </ul>
    </div>
    <pre><code class="language-javascript">
        // Trying to access undefined or null values can cause errors
        const watch = {
          brand: "Seiko",
          type: {
            price: 500,
            strap: "leather",
          }
        };

        console.log(watch.type.weight);  
        // Uncaught TypeError: Cannot read properties of undefined (reading 'type') 

        // Solution without optional chaining
        if (watch.type.weight){
          console.log(watch.type.weight); 
          // Nothing will be logged since the value is undefined
        }

        // Solution with optional chaining
        console.log(watch.type?.weight); // Will log undefined instead of throwing an error

        // Solution with optional chaining and nullish coalescing operator
        console.log(watch.type?.weight ?? "Value does not exist"); 
        // Output: Value does not exist

        // ?. can be used to safely call non-existing methods
        console.log(watch?.tick() ?? "Method does not exist"); 
        // Output: Method does not exist

        // ?. can be used to safely call non-existing array elements
        const profile = [ { name: 'Matthias', email: 'ms@mymail.com'} ];
        console.log(profile?.[1]?.name ?? 'Element does not seem to exist');
        // Output: Element does not seem to exist
    </code></pre>
  </div><!-- end optional chaining -->
</div><!--end operators -->


<div data-id="javascript-javascript utilities" class="level1-container">
<h1>Javascript utilities</h1>
    <div data-id="javascript utilities-numbers">
    <h2>Numbers</h2>
    <h3>Type coercion</h3>
    <div class="info">
    <ul>
    <li>Type coercion: implicit (automatic) conversion from one data type to another</li>
    <li>Type casting / conversion: explicit conversion from one data type to another</li>
    </ul>
    </div>
    <h4>Casting</h4>
    <pre><code class="language-javascript">
    console.log(typeof Number('23')); // Output: number
    </code></pre>
    <h4>Coercion</h4>
    <div class="info">Using the + operator (or another arithmetic operator) on a string will attempt to coerce it to a number</div>
    <pre><code class="language-javascript">
    console.log(typeof +'23'); // Output: number
    console.log(typeof +'hello'); // Output: number (the value itself is NaN)
    </code></pre>
    <h3>Parsing numbers</h3>
    <pre><code class="language-javascript">
        // Parsing a numbers gets rid of trailing characters

        const parsedInt = Number.parseInt('30px');
        console.log(parsedInt); // Output: 30

        const parseFloat = Number.parseFloat('3.1rem');
        console.log(parseFloat); // Output: 3.1

        // The second argument of a parse is the radix to specify the numbers system
        // default is 10 for decimal

        const binaryToDecimal = Number.parseInt('1101', 2);
        console.log(binaryToDecimal); // Output: 13

        const hexaToDecimal = Number.parseInt('0x1F', 16); 
        console.log(hexaToDecimal); // Output: 31
    </code></pre>
    <h3>Number validation</h3>
    <pre><code class="language-javascript">
        // Number.isNaN() checks if the value is equal to NaN

        const isNaN = Number.isNaN(20);
        console.log(isNaN); // Output: false

        /* Number.isFinite() checks if the value is a finite number, 
        it is often used to check wether a value is a number or not.
        Nan, infinity and non-numbers return false */

        const isFinite = Number.isFinite(20); 
        console.log(isFinite); // Output: true

        /* Number.isInteger() checks if the value is an integer
        Keep in mind that floating point values without a fractional part
        (eg 23.0) are stored without the factional part and thus are integers */

        const isInteger1 = Number.isInteger(23); 
        console.log(isInteger1); // Output: true

        const isInteger2 = Number.isInteger(23.0);
        console.log(isInteger2); // Output: true
    </code></pre>
    </div><!-- end numbers -->

    <div data-id="javascript utilities-dates">
    <h2>Dates</h2>
    
    <h3>Creating Dates</h3>
    <pre><code class="language-javascript">
        // Creating a date with the current timestamp
        const now = new Date();
        console.log(now); // Current date and time

        // Creating a date from a string (not recommended)
        const dateFromString = new Date('Aug 02 2020 18:05:41');
        console.log(dateFromString); // Output: Sun Aug 02 2020 18:05:41

        // Creating a date from an ISO 8601 string
        const isoDate = new Date('2024-06-01T21:31:04.904Z');
        console.log(isoDate); // Output: Sat Jun 01 2024 21:31:04 GMT+0000 (UTC)

        // Creating a date by specifying year, month, day, hour, minute, second
        const specificDate = new Date(2037, 10, 19, 15, 23, 5);
        console.log(specificDate); // Output: Thu Nov 19 2037 15:23:05

        // Creating a date from a timestamp (0 milliseconds after Unix Epoch)
        const unixEpoch = new Date(0);
        console.log(unixEpoch); // Output: Thu Jan 01 1970 00:00:00

        // Creating a date from a timestamp offset (e.g., 3 days after Unix Epoch)
        const threeDaysAfterEpoch = new Date(3 * 24 * 60 * 60 * 1000);
        console.log(threeDaysAfterEpoch); // Output: Sun Jan 04 1970 00:00:00
    </code></pre>
    
    <h3>Accessing Date Components</h3>
    <pre><code class="language-javascript">
        // Accessing components of a date
        const myDate = new Date(2025, 0, 15); // Jan 15, 2025

        console.log(myDate.getFullYear()); // Output: 2025
        console.log(myDate.getMonth());    // Output: 0 (January, months are zero-based)
        console.log(myDate.getDate());     // Output: 15
        console.log(myDate.getDay());      // Output: 3 (Wednesday)
        console.log(myDate.getHours());    // Output: 0
        console.log(myDate.getMinutes());  // Output: 0
        console.log(myDate.getSeconds());  // Output: 0
    </code></pre>
    
    <h3>Formatting Dates</h3>
    <pre><code class="language-javascript">
        // Getting the ISO string representation of a date
        console.log(myDate.toISOString()); // Output: 2025-01-15T00:00:00.000Z

        // Getting the timestamp (milliseconds since Unix Epoch)
        console.log(myDate.getTime()); // Output: 1736918400000

        // Shortcut for getting the timestamp
        console.log(+myDate); // Output: 1736918400000
        console.log(Number(myDate)); // Output: 1736918400000
    </code></pre>
    
    <h3>Creating Dates from Timestamps</h3>
    <pre><code class="language-javascript">
        // Creating a date from a timestamp
        const timestamp = myDate.getTime();
        const dateFromTimestamp = new Date(timestamp);
        console.log(dateFromTimestamp); // Output: Wed Jan 15 2025 00:00:00
    </code></pre>
    
    <h3>Working with Timestamps</h3>
    <pre><code class="language-javascript">
        /* Dates are stored in milliseconds after elapsed since
        January 1, 1970, 00:00:00 UTC (Unix Epoch)
        This is why the value returned with Date.now() returns the number
        of milliseconds elapsed since then until now */

        const currentTimestamp = Date.now();
        console.log(currentTimestamp); // Output: 1737141474850
        
        /* Calculating the difference between two dates can be done 
        by subtracting the two dates (milliseconds) from each other 
        and then converting them into the desired format (days, months, ..) */
        
        const date1 = new Date(2025, 0, 15);
        const date2 = new Date(2025, 0, 20);
        
        const differenceInDays = Math.round(Math.abs(date2 - date1) / (1000 * 60 * 60 * 24));
        console.log(differenceInDays); // Output: 5
    </code></pre>
    
    <h3>Setting Date Components</h3>
    <pre><code class="language-javascript">
        const myDate = new Date(2025, 0, 6); // January 15, 2025
        
        // Setting a date component
        myDate.setFullYear(2040);
        console.log(myDate); // Output: Mon Jan 6 2040

        // Padding single-digit date components
        const day = &#096;&#036;{myDate.getDate()}&#096;.padStart(2, '0');
        console.log(day); // Output: 06
    </code></pre>
    
    </div><!-- end dates -->
    
    <div data-id="javascript utilities-internationalization">
    <h2>Internationalization</h2>
    <h3>Formatting Dates</h3>
    <div class="info">
    The Intl.DateTimeFormat object provides a way to format dates based on the user's locale and specific formatting options
    </div>
    <pre><code class="language-javascript">
        // Create a new date
        const myDate = new Date();
        
        // Define options for formatting
        const options = {
          hour: "numeric",
          minute: "numeric",
          day: "numeric",
          month: "numeric",
          year: "numeric",
          // weekday: 'long', // Uncomment to include the full weekday name
        };
        
        // Retrieve the locale from the browser
        const locale = navigator.language;
        
        // Format the date using Intl.DateTimeFormat
        console.log(new Intl.DateTimeFormat(locale, options).format(myDate));
        // Output: Depends on the locale, e.g., "1/16/2025, 10:45 AM" for en-US
    </code></pre>
    
    <h3>Formatting Numbers</h3>
    <div class="info">
    The Intl.NumberFormat object allows you to format numbers according to the specified locale and formatting options.</div>
    <pre><code class="language-javascript">
        // Define options for formatting
        const options = {
          style: 'currency', // Specify the formatting style
          currency: 'EUR',   // Set the currency code (e.g., EUR for Euro)
          // unit: 'celsius', // Uncomment to format with a specific unit
          // useGrouping: false, // Uncomment to remove thousands separators
        };
        
        // Format a number for the en-US locale
        const myNumber = 12345.67; // Example number
        console.log('US: ', new Intl.NumberFormat('en-US', options).format(myNumber));
        // Output: "$12,345.67" for en-US and EUR currency
    </code></pre>
    
    </div><!-- end internationalization -->
    
    
    <div data-id="javascript utilities-math">
    <h2>Math and Numbers</h2>
    
    <h3>Math Functions</h3>
    
    <h4>Roots</h4>
    <pre><code class="language-javascript">
        // Square root and cubic root
        const squareRoot = Math.sqrt(25); // 5
        const squareRootAlt = 25 ** (1 / 2); // 5 (alternative method)
        const cubicRoot = 25 ** (1 / 3); // ~2.924 (cubic root)
    </code></pre>
    
    <h4>Maximum and Minimum</h4>
    <pre><code class="language-javascript">
        // Maximum and minimum
        const max = Math.max(1, 3, 5); // 5 (highest number)
        const min = Math.min(1, 3, 5); // 1 (lowest number)
    </code></pre>
    
    <h4>Constants</h4>
    <pre><code class="language-javascript">
        // Constant PI
        console.log(Math.PI); // 3.141592653589793
    </code></pre>
    
    <h3>Random Numbers</h3>
    <div class="info">
    The Math.random() function generates a random number between 0 and 1. You can scale it to generate numbers in other ranges
    </div>
    <pre><code class="language-javascript">
        // Random number between 0 and 1
        console.log(Math.random()); // Example: 0.834538
        
        // Random integer between 0 and 5
        console.log(Math.trunc(Math.random() * 6)); // Example: 3
        
        // Random integer between 1 and 6
        console.log(Math.trunc(Math.random() * 6) + 1); // Example: 4
        
        // Random integer between min and max
        const min = 1;
        const max = 10;
        console.log(Math.floor(Math.random() * (max - min + 1)) + min); // Example: 7
        
        /* Why use Math.floor instead of Math.trunc?
          Math.floor works correctly with negative numbers, while Math.trunc does not. */
        console.log(Math.floor(-23.6)); // -24
        console.log(Math.trunc(-23.6)); // -23
    </code></pre>
    
    <h3>Rounding and truncating numbers</h3>
    <pre><code class="language-javascript">
        // Rounding methods
        console.log(Math.round(2.9)); // 3 (rounds to nearest integer)
        console.log(Math.floor(2.9)); // 2 (rounds down)
        console.log(Math.ceil(2.3)); // 3 (rounds up)

        // Truncating numbers (removes decimal part)
        console.log(Math.trunc(5.7)); // 5
        
        // Formatting to a fixed number of decimals
        const roundedString = (23.345).toFixed(2); // '23.35' (returns a string)
        const roundedNumber = +(23.345).toFixed(4); // 23.3450 (converts back to number)
    </code></pre>
    
    <h3>Remainder Operator</h3>
    <div class="info">
    The remainder operator % is useful for identifying divisibility and patterns</div>
    <pre><code class="language-javascript">
        // Divisible by two (even numbers)
        console.log(4 % 2 === 0); // true
        
        // Divisble by three
        console.log(6 % 3 === 0); // true
    </code></pre>
    
    <h3>Numeric Separators</h3>
    <div class="info">
    Numeric separators _ improve the readability of large numbers without affecting their value</div>
    <pre><code class="language-javascript">
        const readableNumber = 13_234_123_345;
        console.log(readableNumber); // 13234123345 (underscores ignored in computation)
    </code></pre>
    
    <h3>BigInt</h3>
    <div class="info">
    BigInt is used for working with numbers larger than the 64-bit limit
    </div>
    <pre><code class="language-javascript">
        // Declaring a BigInt using suffix 'n'
        const bigNumber = 1039234923423492341231293123123n;
        
        // Adding a BigInt and a regular number (needs conversion)
        const sum = bigNumber + BigInt(23);
        console.log(sum); // Output: 1039234923423492341231293123146n
    </code></pre>
    </div><!-- end math and numbers -->

    <div data-id="javascript utilities-timers">
    <h2>Timers</h2>
    <div class="info">
    The callback function for setTimeout() and setInterval() run <b>asynchronously</b>.<br>
    This means they do not stop code execution and allow the program to continue running
    </div>
    <h3>Using setTimeout</h3>
    <div class="info">The setTimeout function executes a callback function after a specified delay (in milliseconds)<br>
    It accepts a cbfn, a delay in ms, and any number of comma separated arguments to be used in the cbfn</div>
    <pre><code class="language-javascript">
        const bombComponents = ['timer', 'wires'];

        // Schedule a timer to detonate the bomb after 5 seconds
        const bombTimer = setTimeout(
          (comp1, comp2) => console.log(&#096;The bomb with &#036;{comp1} and &#036;{comp2} detonated!&#096;),
          5000, // Delay in milliseconds
          ...bombComponents // Pass bomb components as arguments to the callback function
        );

        // Cancel the timer if a required component is missing
        if (!bombComponents.includes('timer') || !bombComponents.includes('wires')) {
          clearTimeout(bombTimer); // Bomb doesn't detonate
          console.log('The bomb did not detonate due to missing components.');
        }
    </code></pre>

    <h3>Using setInterval</h3>
    <div class="info">
    The setInterval function executes a callback function repeatedly at a specified interval (in milliseconds)<br>
    It returns (once) an ID for the interval for reference</div>
    <pre><code class="language-javascript">
        // Start logging the date every second
        const intervalId = setInterval(function () {
          const now = new Date();
          console.log(now);
        }, 1000);
        
        // Stop logging after 5 seconds
        setTimeout(function () {
          clearInterval(intervalId); // Stops the interval
          console.log('Stopped logging.');
        }, 5000); // Delay of 5 seconds
    </code></pre>

    <h3>Creating a Countdown Timer</h3>
    <div class="info">Below is an example of a countdown timer that updates every second and stops when it reaches zero</div>
    <pre><code class="language-javascript">
        // Countdown timer function
        const startLogOutTimer = function () {
          const tick = function () {
            const min = String(Math.trunc(time / 60)).padStart(2, 0); // Minutes
            const sec = String(time % 60).padStart(2, 0); // Seconds

            // Display the remaining time
            console.log(&#096;&#036;{min}:&#036;{sec}&#096;);

            // Stop the timer when it reaches zero
            if (time === 0) clearInterval(timer);

            time--; // Decrease time by 1 second
          };

          // Set the countdown duration to 2 minutes (120 seconds)
          let time = 120;

          // Call the tick function immediately to display the initial time
          tick();

          // Schedule the tick function to run every second
          const timer = setInterval(tick, 1000);

          return timer;
        };

        // Start the countdown timer
        startLogOutTimer();
    </code></pre>
  </div><!-- end timers -->

</div><!-- end javascript utilities-->

<div data-id="javascript-object oriented programming" class="level1-container">
  <h1>Object oriented programming</h1>    
  <div data-id="object oriented programming-constructor functions">
    <h2>Constructor functions</h2>
    <div class="info">
    <ul>

    <li>Constructor functions serve as blueprints for creating multiple objects with the same structure and behavior</li>
    <li>It is called with the <b>new</b> keyword, which creates a new object, assigns <b>this</b> to the object, and links it to the constructor's prototype for shared methods</li>
    </ul>
    </div>
    <div class="info">
      What happens when the <b>new</b> keyword is used:
      <ol>
      <li>The <i>new</i> keyword creates an empty object {}</li>
      <li>The constructor function is called from the empty object</li>
      <li>The <i>this</i> keyword inside a function refers to the object calling the function. In this case the empty object</li>
      <li>The new object's <i>.__proto__</i> is linked to the <i>.prototype</i> of the constructor: newObject.__proto__ = Person.prototype</li>
      <li>Optionally instance properties can be set (this.x = y)</li>
      <li>The constructor automatically returns the object (unless a different object is explicitely returned)</li>
      <li>Inheritance: calling properties on the newly created object that are not owned by the object itself but are in the __proto__ property are automatically detected by JS</li>
      <li>The properties and methods will be automatically looked for upward in the prototype chain until it gets to <i>Object.prototype</i>, after which it returns <i>undefined</i></li>
      </ol>
    </div>
    <pre><code class="language-javascript">
        const Person = function (firstName, birthYear){
          this.firstName = firstName;
          this.birthYear = birthYear;
        }
        const matthias = new Person('Matthias', 1990);

        console.log(matthias instanceof Person); // Output: true
    </code></pre>
  </div><!-- end constructor functions -->

  <div data-id="object oriented programming-prototypes">
    <h2>Prototypes</h2>
    <div class="info">
      <b>.__proto__</b><br><br> An internal property of <b>objects</b> that points to the <i>.prototype</i> of the constructor function that created the object using the <i>new</i> keyword<br>
      It is used for property and method lookup in the prototype chain when an object does not have the property or method itself<br><br>
      <b>.prototype</b><br><br>A property (object) of <b>constructor functions</b> that defines the properties for all instances created by that constructor.<br>
      It stores shared properties and methods for all instances created by the constructor<br>
      As soon as a constructor function is defined, a <i>.prototype</i> object is automatically created. It acts as a blueprint for instances created from the constructor.<br>
      <br><br>
      A better name for <i>.prototype</i> would be <i>.prototypeOfLinkedObjects</i> or <i>.prototypeOfInstances</i>
    </div>
    <pre><code class="language-javascript">
        const Person = function (firstName, birthYear){
          this.firstName = firstName;
          this.birthYear = birthYear;
        }

        console.log(Person);
        /* Output: The constructor function itself
        ƒ (firstName, birthYear){
          this.firstname = firstName;
          this.birthYear = birthYear;
        } */

        console.log(Person.prototype); 
        /* Output: shows the prototype object of the constructor function.  
        Paradoxally this prototype object contains the constructor function itself,
        which in turn contains the prototype object. 
        This creates a circular reference where the prototype contains a reference to the constructor, which in turn references the prototype.
        Besides containing the constructor itself, the prototype object 
        also holds the properties that instances created through the constructor will inherit */
    </code></pre>
    <h3>Relationship between .__proto__ and .prototype</h3>
    <h4>Proving instance's .__proto__ links to the constructor's .prototype</h4>
    <div class="info">
      The code below proves that when you create an object using a constructor function (such as new Person()), the created object's <i>.__proto</i> is automatically set to the <i>Person.prototype</i>, allowing the created object to inherit properties and methods from it
    </div>
    <pre><code class="language-javascript">
        function Person(name) {
          this.name = name;
        }

        const matthias = new Person('Matthias');

        console.log(matthias.__proto__ === Person.prototype); 
        // Output: true

        console.log(matthias.__proto__);
        // Output: Person.prototype
    </code></pre>
    <h4>Proving the prototype chain</h4>
    <div class="info">
      The code below proves prototypal inheritance through constructor functions and instances created from them
    </div>
    <pre><code class="language-javascript">
        function Person(name) {
          this.name = name;
        }

        const matthias = new Person('Matthias');

        console.log(matthias.__proto__ === Person.prototype); 
        // Output: true

        console.log(Person.__proto__ === Function.prototype);
        /* Output: true
        Person itself is a function, which in JS are objects too.
        Since Person was created from Function, it's __proto__ is equal to Function.prototype */

        console.log(Function.__proto__ === Object.prototype);
        /* Output: true
        Because Function itself is an object, it has it's .__proto__ set
        to it's constructors .prototype */

        console.log(Object.__proto); 
        /* Output: undefined
        The prototype chain always ends at Object.prototype,
        which is the root prototype for all objects in JavaScript */

        console.log(matthias.__proto__.constructor); 
        /* Output: The constructor function itself which is found on the
        constructor Person prototype

        ƒ (firstName, birthYear){
          this.firstname = firstName;
          this.birthYear = birthYear;
        } */

        console.log(matthias.constructor);
        /* Output: The constructor function itself, which is not found
        on the instance, but is found through the prototype chain 
        on the constructor Person prototype

        ƒ (firstName, birthYear){
          this.firstname = firstName;
          this.birthYear = birthYear;
        } */
    </code></pre>
    <h3>Prototype methods</h3>
    <h4>Adding methods</h4>
    <pre><code class="language-javascript">
        const Person = function (firstName, birthYear){
          this.firstName = firstName;
          this.birthYear = birthYear;
        }

        // This adds a function to the prototype which is accessible to all created instances
        Person.prototype.calcAge = function (){
          console.log(new Date().getFullYear() - this.birthYear);
        }

        // This adds a property to the prototype which is accessible to all created instances
        Person.prototype.species = 'Homo Sapiens';

        const matthias = new Person('Matthias', 1990);
        matthias.calcAge(); // Output: 34
        console.log(matthias.species); // Output: Homo Sapiens
    </code></pre>
    <h4>instanceof (operator)</h4>
    <div class="info">
      instanceof checks if an object was created by a specific constructor function (or one of its descendants).<br>
      It starts with the instance
    </div>
    <pre><code class="language-javascript">
        const Person = function (firstName, birthYear){
          this.firstName = firstName;
          this.birthYear = birthYear;
        }

        const matthias = new Person('Matthias', 1990);

        console.log(matthias instanceof Person);
        /* Output: true
        Because Person.prototype === matthias.__proto__ */
    </code></pre>
    <h4>isPrototypeOf()</h4>
    <div class="info">
      isPrototypeOf() determines whether an object exists in the prototype chain of another object.<br>
      In the code below it checks if Person.prototype exists in matthias' prototype chain.<br>
      It starts with the prototype
    </div>
    <pre><code class="language-javascript">
        const Person = function (firstName, birthYear){
          this.firstName = firstName;
          this.birthYear = birthYear;
        }

        const matthias = new Person('Matthias', 1990);

        console.log(Person.prototype.isPrototypeOf(matthias));
        /* Output: true
        Because Person.prototype === matthias.__proto__ */
    </code></pre>
    <h4>hasOwnProperty()</h4>
    <div class="info">
      hasOwnProperty() checks whether a property belongs to the object itself<br>
      Properties belonging to parents or non-existing in the prototype chain will return false
    </div>
    <pre><code class="language-javascript">
        const Person = function (firstName, birthYear){
          this.firstName = firstName;
          this.birthYear = birthYear;
        }

        const matthias = new Person('Matthias', 1990);

        Person.prototype.species = 'Homo Sapiens';

        console.log(matthias.hasOwnProperty('firstName'))
        /* Output: true
        Because firstName is directly assigned to the instance matthias */

        console.log(matthias.hasOwnProperty('species'));
        /* Output: false
        Because the property is inherited from Person.prototype, not directly assigned to matthias */
    </code></pre>
    <h3>Prototype overview</h3>
    <pre><code class="language-javascript">
        const Person = function (firstName, birthYear){
          this.firstName = firstName;
          this.birthYear = birthYear;
        }

        const matthias = new Person('Matthias', 1990);

        console.log(matthias.__proto__ === Person.prototype); 
        /* Output: true, an instance's __proto__ points to the prototype of 
        its constructor (Person.prototype) */

        console.log(Person.__proto__ === Function.prototype); 
        /* Output: true, Person is a function, and all functions
        inherit from Function.prototype */

        console.log(Function.__proto__ === Object.prototype); 
        /* Output: true, Function itself is an object, and its __proto__ points to Object.prototype */

        console.log(Person.prototype.__proto__ === Object.prototype); 
        /* Output: true, Person.prototype is an object, so its __proto__ points to Object.prototype */

        console.log(matthias.__proto__.__proto__ === Object.prototype);
        /* Output: true, matthias.__proto__ points to Person.prototype, and Person.prototype.__proto__ points to Object.prototype */


        console.log(matthias.constructor === matthias.__proto__.constructor);
        /* Output: true, matthias.constructor is resolved through the prototype chain, and it refers to Person */
    </code></pre>
  </div><!-- end prototypes -->


  <div data-id="object oriented programming-classes">
    <h2>Classes</h2>
    <div class="info">
      Classes work behind the scenes just like prototypes. They provide syntactic sugar that hides the complexity of prototypes and makes the code more readable
    </div>
    <h3>Declarations and Expressions</h3>
    <h4>Class expressions</h4>
    <div class="info">
    A class expression is similar to a function expression. <br>It allows you to define a class inline, and it can be either named or anonymous.<br>
    However class declarations are more commonly used
    </div>
    <pre><code class="language-javascript">
        /* Anonymous class expression */

        const Person = class {
          constructor(name, age) {
            this.name = name;
            this.age = age;
          }

          greet() {
            console.log(&#096;Hello, my name is &#036;{this.name}.&#096;);
          }
        };

        const matthias = new Person('Matthias', 34);

        /* Named class expression
        These are only useful if you need to reference the classname in the class itself without affecting the outer scope. Or if you want clearer error messages (class will be named) */

        // Will have Car class in the error
        const MyCar = class Car {
          constructor() {
            throw new Error("Car initialization failed");
          }
        };
    </code></pre>
    <h4>Class declaration</h4>
    <div class="info">
    A class declaration is similar to a function declaration.<br> It allows you to define a class with a specific name
    </div>
    <pre><code class="language-javascript">
        class Person {
          constructor(firstName, birthYear) {
            this.firstName = firstName; 
            this.birthYear = birthYear;
          }

          // Instance method (added to the .prototype of the class)
          calcAge() {
            console.log(new Date().getFullYear() - this.birthYear);
          }
        };

        // Methods can still be manually added via the prototype object
        Person.prototype.greet = function () {
          console.log(&#096;Hey &#036;{this.firstName}&#096;);
        };

        const matthias = new Person('Matthias', 1990);
        matthias.calcAge(); // Output: 34
        matthias.greet(); // Output: Hey Matthias
    </code></pre>


    <h3>Using Getters and Setters with Classes</h3>
    <div class="info">
      In classes, getters and setters can also be used. <br>
      Getters and setters look like regular properties, but behave as functions.<br>
      They make it possible to allow controlled access to properties
    </div>
    <pre><code class="language-javascript">
        class Person {
          constructor(name) {
            this.name = name; // Triggers the setter
          }

          // Setter to ensure the name is valid
          set name(value) {
            if (value.includes(" ")) this._name = value;
            else console.error("Name must include a space!");
          }

          // Getter to retrieve the name
          get name() {
            return this._name;
          }
        }

        const person = new Person("Matthias Swerts");
        console.log(person.name); // Output: Matthias Swerts

        person.name = "Matthias"; // Output: Name must include a space!
    </code></pre>
    <h4>Using _ to avoid infinite loops</h4>
    <pre><code class="language-javascript">
        // Problem: infinitely calling setter

        class Person {
          constructor(name) {
            this.name = name; // Triggers the setter
          }

          // Setter
          set name(value) {
            // This directly assigns 'this.name', which triggers the setter again
            this.name = value; // Infinite loop
          }

          // Getter
          get name() {
            return this.name; // Triggers the getter
          }
        }

        const person = new Person("John Doe"); // Causes a stack overflow due to infinite recursion

        // Solution: using _ to make the setter access an internal property instead of the setter again

        class Person {
          constructor(name) {
            this._name = name; // Directly assign to the internal property
          }

          // Setters
          set name(value) {
            if (value.includes(" ")) this._name = value; // Valid assignment
            else console.error("Name must include a space");
          }

          // Getter
          get name() {
            return this._name; // Access the internal property
          }
        }

        const person = new Person("John Doe");
        console.log(person.name); // Output: John Doe
        person.name = "Jane"; // Output: Name must include a space
    </code></pre>
    <h3>Default values</h3>
    <div class="info">
    You can use <b>instance field declarations</b> or just use short circuiting
    </div>
    <pre><code class="language-javascript">
        // Using instance field declarations

        class Config1 {
          // Instance field declarations
          environment = "test"; // Default value
          debug = false;

          // Override if argument has a value
          constructor({ environment, debug } = {}) { // default to {} to prevent errors when calling the constructor without an argument
            if (environment) this.environment = environment;
            if (debug !== undefined) this.debug = debug;
          }
        }

        const defaultConfig = new Config1(); 
        /* Even though no argument is provided, 
          this will not error because the constructor defaults to {} */

        // Using short circuiting

        class Config2 {
          constructor({ environment, debug } = {}) {
            this.environment = environment || "test"; // You can use || because it is a string thats unlikely to contain falsy values
            this.debug = debug ?? false; // Use ?? because false is a falsy but valid value
          }
        }
    </code></pre>

    <h3>Static Methods</h3>
    <div class="info">
      Static methods are methods that belong to the class itself, not to instances of the class.<br>
      They can only be called on the class and not on an instance of the class
    </div>
    <pre><code class="language-javascript">
        class MathHelper {
          // Static method
          static add(a, b) {
            return a + b;
          }
        }

        // Call static methods directly on the class
        console.log(MathHelper.add(5, 3)); // Output: 8

        // Add a static method dynamically
        MathHelper.multiple = function(a, b){
          return a * b;
        }

        // Examples
        const p = new PersonCl();
    </code></pre>

    <h3>Creating Instances: Three Approaches</h3>

    <h4>Creating instances using Constructor Functions</h4>
    <pre><code class="language-javascript">
        const Person = function (firstName, birthYear) {
          this.firstName = firstName; // Assign properties
          this.birthYear = birthYear;
        };

        // Create an instance
        const matthias = new Person('Matthias', 1990);

        console.log(matthias.firstName); // Output: Matthias
    </code></pre>

    <h4>Creating instances using Class Syntax (ES6+)</h4>
    <pre><code class="language-javascript">
        class Person {
          constructor(fullName, birthYear) {
            this.fullName = fullName;
            this.birthYear = birthYear;
          }
        }

        const p = new Person(' Matthias', 1990);
        console.log(p.fullName); // Output: Matthias
    </code></pre>

    <h4>Creating instances using <i>Object.create</i></h4>
    <pre><code class="language-javascript">
        const PersonProto = {
          calcAge() {
            console.log(new Date().getFullYear() - this.birthYear);
          },
          init(firstName, birthYear) {
            this.firstName = firstName;
            this.birthYear = birthYear;
          },
        };

        const matthias = Object.create(PersonProto);
        steven.init('Matthias', 1990);
        steven.calcAge(); // Output: 47
    </code></pre>

    <h3>Using Class Methods as Callback Functions</h3>
    <h4>Problem illustration</h4>
    <div class="info">
    When you pass a class method as a callback, it loses its connection to the class instance.<br>
    This happens because the method is treated as a regular function, and <i>this</i> no longer points to the class.<br> As a result, properties or methods that rely on <i>this</i> will not work as expected
    </div>
    <pre><code class="language-javascript">
        class Timer {
          constructor(seconds) {
            this.seconds = seconds;
          }

          start() {
            console.log(&#096;Timer started for &#036;{this.seconds} seconds...&#096;);
            setTimeout(this.showTime, this.seconds * 1000); 
            // Problem: 'this' context is lost
          }

          showTime() {
            console.log(&#096;Timer finished after &#036;{this.seconds} seconds&#096;); 
          }
        }

        const timer = new Timer(3);
        timer.start(); // Error: 'this.seconds' is undefined
    </code></pre>
    <h4>Solution</h4>
    <div class="info">
    To fix this, you can use .bind(this) or an arrow function to retain the correct <i>this</i> context
    </div>
    <pre><code class="language-javascript">
        class Timer {
          constructor(seconds) {
            this.seconds = seconds;
          }

          start() {
            console.log(&#096;Timer started for &#036;{this.seconds} seconds...&#096;);
            setTimeout(this.showTime.bind(this), this.seconds * 1000); 
            // Correct context is retained
          }

          showTime() {
            console.log(&#096;Timer finished after &#036;{this.seconds} seconds&#096;); 
            // Works correctly
          }
        }

        const timer = new Timer(3);
        timer.start();
    </code></pre>

    <h3>Class Inheritance</h3>

    <h4>Inheritance using constructor functions</h4>
    <div class="info">
      You can implement inheritance by manually linking prototypes when using constructor functions
    </div>
    <pre><code class="language-javascript">
        const Person = function (firstName, birthYear) {
          this.firstName = firstName;
          this.birthYear = birthYear;
        };

        // Adding a method to Person's prototype
        // This method can be used by all instances of Person to calculate their age
        Person.prototype.calcAge = function () {
          console.log(2037 - this.birthYear);
        };

        // Child constructor function: Student
        const Student = function (firstName, birthYear, course) {
          // Call the parent constructor to initialize firstName and birthYear
          Person.call(this, firstName, birthYear); 
          this.course = course; // Initialize the course property specific to Student
        };

        // Linking prototypes makes Student inherit methods from Person (e.g., calcAge)
        Student.prototype = Object.create(Person.prototype);

        // Add a new method to Student's prototype
        // This method is specific to Student and not available on Person
        Student.prototype.introduce = function () {
          console.log(&#096;My name is &#036;{this.firstName} and I study &#036;{this.course}&#096;);
        };

        const mike = new Student('Mike', 2020, 'Computer Science');

        mike.introduce(); // Output: My name is Mike and I study Computer Science

        mike.calcAge(); // Output: 17
    </code></pre>

    <h4>Inheritance using ES6 Classes</h4>
    <div class="info">
      Using classes is the most conventional way.<br>
      Use the <i>extends</i> keyword to create a subclass and <i>super</i> to call the parent constructor.
    </div>
    <pre><code class="language-javascript">
        class Person {
          constructor(fullName, birthYear) {
            this.fullName = fullName;
            this.birthYear = birthYear;
          }
          calcAge() {
            console.log(2037 - this.birthYear);
          }
        }

        class Student extends Person {
          constructor(fullName, birthYear, course) {
            super(fullName, birthYear); // Call parent constructor
            this.course = course;
          }

          introduce() {
            console.log(&#096;My name is &#036;{this.fullName} and I study &#036;{this.course}&#096;);
          }

          calcAge() {
            console.log('This method is overridden in the subclass!');
          }
        }

        const martha = new Student('Martha Jones', 2012, 'Mathematics');
        martha.introduce(); // Output: My name is Martha Jones and I study Mathematics
        martha.calcAge(); // Output: This method is overridden in the subclass!
    </code></pre>

    <h4>Inheritance using Object.create()</h4>
    <div class="info">
      Not commonly used.<br>  
      The <i>Object.create()</i> method creates a new object with the specified prototype object
    </div>
    <pre><code class="language-javascript">
        /* Define a prototype object with shared methods */
        const PersonProto = {
          calcAge() {
            console.log(new Date().getFullYear() - this.birthYear);
          },
          init(firstName, birthYear) {
            this.firstName = firstName;
            this.birthYear = birthYear;
          },
        };

        /* Create a new prototype that inherits from PersonProto */

        const StudentProto = Object.create(PersonProto); 
        // Creates an object with .__proto__ set to PersonProto

        StudentProto.init = function (firstName, birthYear, course) {
          PersonProto.init.call(this, firstName, birthYear); // Reuse the parent init method
          this.course = course;
        };

        StudentProto.introduce = function () {
          console.log(&#096;My name is &#036;{this.firstName} and I study &#036;{this.course}&#096;);
        };

        const jay = Object.create(StudentProto); 
        // Creates an object with .__proto__ set to StudentProto

        jay.init('Jay', 2010, 'Computer Science');
        jay.introduce(); // Output: My name is Jay and I study Computer Science
        jay.calcAge(); // Output: 24
    </code></pre>

  </div><!-- end classes -->

  <div data-id="object oriented programming-encapsulation">
    <h2>Encapsulation</h2>
   
    <h3>Public and Private Fields</h3>
    <div class="info">
      Fields are properties set on the instance itself, not on its <i>__proto__</i>.<br>
      Public fields are accessible anywhere, while private fields are restricted to the class itself
    </div>
    <pre><code class="language-javascript">
        class User {
          // Public property: accessible outside the class
          username;

          // Private field: only accessible inside the class
          #password;

          constructor(username, password) {
            this.username = username; 
            this.#password = password; 
          }

          login(password) {
            if (password === this.#password) {
              console.log(&#096;&#036;{this.username} logged in.&#096;);
            } else {
              console.log('Incorrect password!');
            }
          }
        }

        const user1 = new User('john_doe', 'secure123');

        // Accessing public field
        console.log(user1.username); // Output: john_doe

        // Attempting to access private field
        console.log(user1.#password); // Error: Private field '#password'

        user1.login('secure123'); // Output: john_doe logged in.
        user1.login('wrong'); // Output: Incorrect password!
    </code></pre>
    
    <h3>Private Methods</h3>
    <div class="info">
      Private methods are methods that can only be accessed within the class itself.<br> They are useful for encapsulating internal logic
    </div>
    <pre><code class="language-javascript">
        class User {
          #password;

          constructor(username, password) {
            this.username = username;
            this.#password = password;
          }

          login(inputPassword) {
            console.log(this.#validatePassword(inputPassword) ? 'Login successful!' : 'Incorrect password.');
          }

          // Private method is not accessible outside the class itself
          #validatePassword(password) {
            return password === this.#password;
          }
        }

        const user = new User('john_doe', 'secure123');
        user.login('secure123'); // Output: Login successful!
        user.login('wrongpass'); // Output: Incorrect password.
        user.#validatePassword('secure123'); // Error: private method
    </code></pre>
 
  </div><!-- end encapsulation -->
</div><!-- end oop -->

<!-- ERROR HANDLING -->

<div data-id="javascript-error handling" class="level1-container">
  <h1>Error Handling</h1>

  <div data-id="error handling-try catch finally">
    <h2>Try / catch / finally</h2>
    <div class="info">
      <ul>
        <li>Code inside <i>try</i> runs first; if it throws, execution jumps straight to <i>catch</i></li>
        <li>The <i>catch</i> parameter is optional since ES2019 (<i>catch {}</i>) when you don't need the error itself</li>
        <li><i>finally</i> always runs, whether an error was thrown or not</li>
      </ul>
    </div>
    <pre><code class="language-javascript">
        function parseAge(input) {
          try {
            const age = JSON.parse(input);
            console.log(&#96;Parsed age: &#36;{age}&#96;);
          } catch (error) {
            console.log('Could not parse age:', error.message);
          } finally {
            console.log('Parsing attempt finished');
          }
        }

        parseAge('25'); // Output: Parsed age: 25 / Parsing attempt finished
        parseAge('not a number'); // Output: Could not parse age: ... / Parsing attempt finished
    </code></pre>
  </div>

  <div data-id="error handling-throw and the error object">
    <h2>Throw &amp; the Error object</h2>
    <div class="info">
      <ul>
        <li><i>throw</i> can throw any value, but throwing an <i>Error</i> object is the convention since it carries a <i>.message</i>, <i>.name</i> and <i>.stack</i></li>
        <li>An uncaught throw stops the script (or, in an async function, rejects the returned promise)</li>
      </ul>
    </div>
    <pre><code class="language-javascript">
        function withdraw(balance, amount) {
          if (amount > balance) {
            throw new Error('Insufficient funds');
          }
          return balance - amount;
        }

        try {
          withdraw(100, 150);
        } catch (error) {
          console.log(error.message); // Output: Insufficient funds
          console.log(error.name); // Output: Error
        }
    </code></pre>
  </div>

  <div data-id="error handling-custom error classes">
    <h2>Custom error classes</h2>
    <div class="info">Extending the built-in <i>Error</i> class lets you create specific error types that can be told apart with <i>instanceof</i></div>
    <pre><code class="language-javascript">
        class ValidationError extends Error {
          constructor(message) {
            super(message);
            this.name = 'ValidationError';
          }
        }

        function setAge(age) {
          if (age < 0) {
            throw new ValidationError('Age cannot be negative');
          }
        }

        try {
          setAge(-5);
        } catch (error) {
          if (error instanceof ValidationError) {
            console.log(&#96;Validation failed: &#36;{error.message}&#96;); // Output: Validation failed: Age cannot be negative
          } else {
            throw error; // Re-throw anything we didn't expect
          }
        }
    </code></pre>
  </div>
</div><!-- end error handling -->

<div data-id="javascript-asynchronous javascript" class="level1-container">
  <h1>Async Programming</h1>
  
  <h2>Asynchronicity</h2>

  <div data-id="asynchronous javascript-asynchronicity">
    <h3>What is asynchronicity</h3>
    <div class="info">
      Asynchronicity allows JavaScript to handle tasks like I/O operations (e.g., file reading, network requests) without blocking the execution of other code.
      <br><br>
      In asynchronous code, tasks that take time are delegated, allowing the program to continue running other operations
    </div>

    <h4>Example of synchronous vs asynchronous</h4>

    <pre><code class="language-javascript">
        // Synchronous (blocking)
        console.log('Start');
        console.log('Task running...');
        console.log('End');

        // Asynchronous (non-blocking)
        console.log('Start');
        setTimeout(() => console.log('Task running...'), 1000);
        console.log('End');
        /* Output:
          Start
          End
          Task running...
        */
    </code></pre>
  
    <h3>Asynchronous with callbacks</h3>
    <pre><code class="language-javascript">
        const fs = require('fs');

        console.log('Start');

        // Reads the file asynchronously and executes the callback function once the file is read
        fs.readFile('example.txt', 'utf8', (err, data) => {
          if (err) {
            console.error('Error reading file:', err.message);
            return;
          }
          console.log('File content:', data); 
        });

        console.log('End');

        /* Output:
        Start
        End
        File content: Hello, World! */
    </code></pre>
  
    <h3>Drawbacks of callbacks</h3>
    <div class="info">
    <ul>
      <li>Using callbacks can lead to "<b>callback hell</b>" when tasks are deeply nested, making the code difficult to read and maintain.</li>
      <li>To maintain a certain order with these async requests, the next request has to be handled inside the cbfn of the previous one</li>
    <li>Callback hell is usually noticable by the triangular shape of the code</li>
    </ul>
    </div>
    <pre><code class="language-javascript">
        function fetchData(callback) {
          setTimeout(() => {
            console.log('Fetching data...');
            callback('Data 1', (data2) => {
              setTimeout(() => {
                console.log('Fetching more data...');
                callback('Data 2', (data3) => {
                  setTimeout(() => {
                    console.log('Fetching even more data...');
                    console.log('All data retrieved!');
                  }, 1000);
                });
              }, 1000);
            });
          }, 1000);
        }
    </code></pre>
  
    <h3>Asynchronous with promises</h3>
    <div class="info">
      Promises solve the problem of callback hell by providing a cleaner, chainable way to handle asynchronous tasks
    </div>
  </div> <!-- end asynchronous -->

  <h2>Promises</h2>
  <div data-id="asynchronous javascript-promises">
    <h3>What is a promise</h3>
    <div class="info">
      A promise is an object that represents the final success (fulfilled) or failure (rejected) of an asynchronous action
      <br><br>
      Promises have 3 states:
      <ul>
        <li><b>Pending</b>: Initial state, the process is ongoing</li>
        <li><b>Fulfilled/Resolved</b>: The async process is finished with a result</li>
        <li><b>Rejected</b>: The async processs failed with an error</li>
      </ul>
    </div>
    <pre><code class="language-javascript">
        const promise = new Promise((resolve, reject) => {
          // When the function is still running, the promise state is pending
          Math.random() > 0.5 ? resolve('Fulfilled!') : reject('Rejected!');
        });

        console.log('Promise object', promise);
        /* Output:
          In case resolve was called: Promise fulfilled: 'Fulfilled!'
          In case reject was called: Promise rejected: 'Rejected!'
    </code></pre>

    <h3>Creating a promise object</h3>
    <div class="info">
      A promise object is created with a promise constructor which uses a cbfn that gets passed 2 parameters:<br> a resolve cbfn and a reject cbfn. 
      Often used for <i>Promisifying</i>.
      <ul>
        <li><b>Resolve</b>: Called to fullfill the promise</li>
        <li><b>Reject</b>: Called to reject the promise</li>
      </ul>
    </div>
    <pre><code class="language-javascript">
        const promise = new Promise((resolve, reject) => {
          if (Math.random() > 0.5){
            resolve('Fulfilled!')
          }else{
            reject('Rejected!');
          }
        });

        promise
          .then(result => console.log(result)) // Output if fulfilled: Fulfilled!
          .catch(error => console.error(error)) // Output if rejected: Rejected!
          .finally(() => console.log('Promise complete')); // Output always executes: 'Promise complete'
    </code></pre>

    <h3>Resolving and rejecting promises</h3>
    <div class="info">
      There are two ways to resolve or reject promises
      <ul>
        <li>The reject() and resolve() callbackfunctions inside a new Promise constructor <b>(asynchronous)</b></li>
        <li>Promise.resolve() and Promise.reject() <b>(not asynchronous)</b></li>
      </ul>
    </div>

    <h4>Resolve() and reject() Promise constructor callbacks</h4>
    <div class="info">
      <ul>
        <li>Use resolve() on asynchronous operations that are fullfilled</li>
        <li>Use reject() on asynchronous operations that failed</li>
      </ul>
    </div>
    <pre><code class="language-javascript">
        function fetchData() {
            return new Promise((resolve) => {
                setTimeout(() => {
                    resolve("Data successfully retrieved!");
                }, 2000);
            });
        }

        fetchData().then(data => console.log(data)); 
        // Output after 2 sec: Data successfully retrieved!
    </code></pre>
    <pre><code class="language-javascript">
        function fetchData() {
            return new Promise((resolve, reject) => {
                setTimeout(() => {
                    reject(new Error("Failed to fetch data!"));
                }, 2000);
            });
        }

        fetchData()
            .then(data => console.log("Data:", data)) // Wordt overgeslagen
            .catch(error => console.log("Caught error:", error.message)); 
        // Output after 2 sec: Caught error: Failed to fetch data!
    </code></pre>

    <h4>Promise.resolve() and Promise.reject()</h4>
    <div class="info">
      <ul>
        <li>Promise.resolve() and Promise.reject() immediately create a resolved or rejected Promise object</li>
        <li>Use Promise.resolve() when you already have a value and want to wrap it in a Promise without performing an asynchronous operation</li>
        <li>Use Promise.reject() when you want to simulate a rejected promise without an actual asynchronous operation</li>
      </ul>
    </div>
    <pre><code class="language-javascript">
        /* This example uses Promise.resolve() to consistently make the function return a Promise,
        even when the data is already available and no asynchronous operation is necessary.
        Without consistenly returning promises, the output type from this function is unexpected */

        function getUser(userId) {
            // Immediately returns a rejected promise if the data is not valid and no async operation is required
            if (typeof userId !== "number" || userId <= 0) {
                return Promise.reject(new Error("Invalid user ID"));
            }

            const user = { id: userId, name: "Matthias" };

            // Immediately returns a fulfilled promise when the data is already present and no async operation is required
            // Otherwise it starts an async operation that is resolved using the promise constructor on fullfillment
            return user
                ? Promise.resolve(user)  
                : new Promise(resolve => 
                    setTimeout(() => resolve({ id: userId, name: "New User" }), 2000)
                );
        }

        getUser(-1)
            .then(user => console.log("User:", user))
            .catch(error => console.log("Caught error:", error.message));
    </code></pre>

 


    <h3>Promise methods</h3>
    <div class="info">
    A promise object has methods to handle it:
    <ul>
      <li><b>.then()</b>: Executes only when the promise is fulfilled</li>
      <li><b>.catch()</b>: Executes when the promise is rejectedt</li>
      <li><b>.finally()</b>: Executes regardless if the promise was fulfilled or rejected</li>
    </ul>
  </div>
  <pre><code class="language-javascript">
        promise
          .then(result => console.log(result)) // Output if fulfilled: Fulfilled
          .catch(error => console.error(error)) // Output if rejected: Rejected
          .finally(() => console.log('Promise complete')); // Output always executes: 'Promise complete'
  </code></pre>
  <h4>.then()</h4>
  <div class="info"><ul><li>The <i>.then()</i> method gets called when the Promise is fulfilled/resolved</li>
  <li>The Promise passes it's value to the cbfn of the <i>.then()</i></li>
  <li>A <i>.then()</i> always returns a value. If no value is given to return it returns 'undefined'</li>
  </ul>
  </div>
  <pre><code class="language-javascript">
        let numberPromise = new Promise(resolve => {
          resolve(5);
        });

        numberPromise
            .then(number => {
                console.log("First .then():", number); // Output: First .then(): 5
                return number * 2;
            })
            .then(result => {
                console.log("Second .then():", result); // Output: Second .then(): 10
                return result + 3;
            })
            .then(finalResult => {
                console.log("Third .then():", finalResult); // Output: Third .then(): 13
            });
  </code></pre>

  <h4>.catch()</h4>
  <div class="info">
    <ul>
      <li>The <i>.catch()</i> method gets called when the Promise is rejected</li>
      <li>The Promise passes its rejection reason (error) to the callback function of the <i>.catch()</i></li>
      <li>A <i>.catch()</i> always returns a value. If no value is given to return, it returns 'undefined'.</li>
      <li>If a <i>.catch()</i> is placed in a Promise chain, it stops error propagation and allows the chain to continue</li>
    </ul>
  </div>
  <pre><code class="language-javascript">
        let rejectedPromise = new Promise((resolve, reject) => {
            reject(new Error("Something went wrong!"));
        });

        rejectedPromise
            .then(number => {
                console.log("This will not run because the Promise was rejected.");
                return number * 2;
            })
            .catch(error => {
                console.log("Caught in .catch():", error.message); // Output: Caught in .catch(): Something went wrong!
                return "Recovered"; // Returning a value to continue the chain
            })
            .then(result => {
                console.log("Second .then() after catch:", result); // Output: Second .then() after catch: Recovered
            });
  </code></pre>

  <h4>.finally()</h4>
  <div class="info">
    <ul>
      <li>The <i>.finally()</i> method gets called when the Promise is settled (either fulfilled/resolved or rejected).</li>
      <li>It is typically used for cleanup tasks, such as hiding a loading spinner.</li>
    </ul>
  </div>
  <pre><code class="language-javascript">
        let rejectedAsyncPromise = new Promise((resolve, reject) => {
            setTimeout(() => reject(new Error("Something went wrong!")), 1000);
        });

        rejectedAsyncPromise
            .then(result => console.log("Success:", result))
            .catch(error => console.log("Caught error:", error.message)) // Output: Caught error: Something went wrong!
            .finally(() => console.log("Cleanup complete.")); // Output: Cleanup complete.
  </code></pre>


  </div> <!-- end promises -->
  

    <div data-id="asynchronous javascript-ajax">
      <h2>AJAX</h2>
      <div class="info">
        <ul>
          <li>AJAX stands for Asynchronous JavaScript and XML and is used to fetch data from a server without reloading the page</li>
          <li>Older methods, such as <b>XMLHttpRequest</b>, can lead to callback hell due to deeply nested callbacks</li>
          <li>Newer methods, like <b>fetch</b>, use promises to enable cleaner, flatter chains of asynchronous calls</li>
        </ul>
      </div>
      <h3>Old Skool: XMLHttpRequest</h3>
      <pre><code class="language-javascript">
        const getUserFirstPost = () => {
          const userRequest = new XMLHttpRequest();
          userRequest.open('GET', &#096;https://jsonplaceholder.typicode.com/users/1&#096;);
          userRequest.send();

          userRequest.addEventListener('load', () => {
            const user = JSON.parse(userRequest.responseText);
            console.log('User:', user.name);

            const postsRequest = new XMLHttpRequest();
            postsRequest.open('GET', &#096;https://jsonplaceholder.typicode.com/posts?userId=&#036;{user.id}&#096;);
            postsRequest.send();

            postsRequest.addEventListener('load', () => {
              const posts = JSON.parse(postsRequest.responseText);
              console.log('First post:', posts[0].title);
            });
          });
        };

        getUserFirstPost();
      </code></pre>
  
      <h3>Modern: Fetch API</h3>
      <div class="info">
        Each time a promise is returned it has to be caught with a <i>.then()</i>, or an <i>await</i>
      </div>
      <pre><code class="language-javascript">
        const getDogFact = function () {
          fetch('https://dog-api.kinduff.com/api/facts')
            .then(function (response) {
              return response.json(); // Parse response body as JSON
            })
            .then(function (data) {
              console.log('Did you know about dogs:', data.facts[0]);
            })
            .catch(function (error) {
              console.error('An error occurred:', error);
            });
        };

        getDogFact();
      </code></pre>
      <div class="info">
        <p><b>Important:</b></p>
        <ul>
          <li>A fetch request only returns a rejected promise for network errors. HTTP status codes like 404 or 500 are considered resolved promises</li>
          <li>Use the <i>ok</i> property of the response to detect such errors</li>
        </ul>
      </div>
      <pre><code class="language-javascript">
        /* The catch block handles rejected promises as well as thrown errors */

        fetch(&#096;https://pokeapi.co/api/v2/pokemon/pikachu&#096;)
        .then(function (response) {
          if (!response.ok) throw new Error(&#096;Pokemon not found (&#036;{response.status})&#096;);
          return response.json();
        })
        .then(function (data) {
          console.log('Pokemon Name:', data.name);
          console.log('First Ability:', data.abilities[0].ability.name);
        })
        .catch(function (err) {
          console.error(&#096;&#036;{err.message} 💥&#096;);
        });
      </code></pre>
    </div><!-- end ajax -->


  <div data-id="asynchronous javascript-async/await">
    <h2>Async/Await</h2>
    <div class="info">
      <ul>
        <li><b>Async/await</b> provides a cleaner and more readable way to handle promises compared to <i>.then()</i></li>
        <li>The <b>async</b> keyword makes a function <u>always</u> return a promise, even if no explicit return statement is present</li>
        <li>The <b>await</b> keyword pauses the execution of the async function until the promise resolves or rejects</li>
        <li>The <b>await</b> keyword retrieves the inner value of the returned Promise object</li>
        <li>Errors (and rejected promises) inside async functions can be caught using a <b>try/catch</b> block</li>
      </ul>
    </div>
    <h3>Fetching data with Async/Await</h3>
    <pre><code class="language-javascript">
        const getPokemonData = async function (pokemon) {
          try {
            const res = await fetch(&#096;https://pokeapi.co/api/v2/pokemon/&#036;{pokemon}&#096;);
            if (!res.ok) throw new Error(&#096;Pokemon not found (&#036;{res.status})&#096;);
            const data = await res.json();
            console.log(data);
          } catch (err) {
            console.error(&#096;An error occurred: &#036;{err.message}&#096;);
          }
        };

        getPokemonData('pikachu');
    </code></pre>
    <h3>Returning promises in async functions</h3>
    <div class="info">
    <ul>
    <li>A function tagged with async <b>always</b> returns a Promise object</li>
    <li>The return value of that async function becomes the resolved value of that Promise</li>
    <li>This resolved (internal) value is only accessible through .then(), .catch() or await</li>
    <li>If there is no explicit return (using oneline arrow function or the 'return' keyword), the promises' resolved value will be 'undefined'</li>
    <li>If an error is thrown inside the async function, the error becomes the <b>rejected</b> value of the Promise</li>
    </ul>
    </div>
    <h4>Async functions always return a promise</h4>
    <pre><code class="language-javascript">
        async function sayHi() {
          return "Hello!";
        }

        console.log(sayHi()); // Promise { fulfilled: "Hello!" }
    </code></pre>
    <h4>The return value becomes the Promises' resolved value</h4>
    <pre><code class="language-javascript">
        async function sayHi() {
          return "Hello!";
        }

        sayHi().then(result => console.log(result)); // Output: Hello!
    </code></pre>
    <h4>The internal value is only accessible using <i>.then()</i>, <i>.catch()</i>, or <i>await</i></h4>
    <pre><code class="language-javascript">
        async function sayHi() {
          return "Hello!";
        }

        const result = sayHi(); // This is a Promise, not "Hello!"
        console.log(result); // Output: Promise { fulfilled: "Hello!" }

        result.then(data => console.log("Resolved value:", data)); // Output: Resolved value: Hello!
    </code></pre>
    <h4>Without an explicit return, the Promise resolves with <i>undefined</i></h4>
    <pre><code class="language-javascript">
        async function sayHi() {
          console.log("No return statement");
        }
      
        sayHi().then(result => console.log("Resolved value:", result));
        // Output: 
        // No return statement
        // Resolved value: undefined
    </code></pre>
    <h4>Thrown errors will reject the promise status</h4>
    <pre><code class="language-javascript">
        async function sayHi() {
          throw new Error('Something went wrong saying Hi');
        }
      
        const result = sayHi();
        console.log(result); // Output: Promise { rejected: Error: Something went wrong! }
        
        result.catch(error => console.log("Caught error:", error.message)); 
        // Output: Caught error: Something went wrong saying Hi
    </code></pre>
    <h3>Comparison .then() vs async/await</h3>
    <pre><code class="language-javascript">
        // Using .then()
        function getData() {
          return fetch(&#096;https://api.example.com/data&#096;)
            .then(response => response.json())
            .then(data => console.log(data))
            .catch(error => console.error(&#096;Error: &#036;{error.message}&#096;));
        }

        // Using async/await
        async function getData() {
          try {
            const response = await fetch(&#096;https://api.example.com/data&#096;);
            const data = await response.json();
            console.log(data);
          } catch (error) {
            console.error(&#096;Error: &#036;{error.message}&#096;);
          }
        }
    </code></pre>
  </div><!-- end async await -->


  <div data-id="asynchronous javascript-error handling">
    <h2>Error Handling</h2>
    <h3>Handling rejected promises with .catch()</h3>
    <pre><code class="language-javascript">
        function rejectedPromise() {
            return new Promise((_, reject) => {
                reject(new Error("Request failed!"));
            });
        }

        rejectedPromise().catch(error => console.log("Caught error:", error.message));
    </code></pre>
    <h4>Error handling for fetch requests</h4>
    <div class="info">
    <ul>
      <li>For fetch requests, a rejected promise only occurs for network errors (e.g., no internet). HTTP response codes like 404 or 500 are considered fulfilled promises.</li><li>Use the <i>reponse.ok</i> property to check for unexpected http statuses when using fetch</li>
    </ul>
  </div>
    <pre><code class="language-javascript">
        // Fetching a nonexisting pokemon to induce a 404 response
        fetch(&#096;https://pokeapi.co/api/v2/pokemon/unknown-pokemon&#096;)
          .then(response => {
            if (!response.ok) throw new Error(&#096;Pokemon not found (status: &#036;{response.status})&#096;);
            return response.json();
          })
          .then(data => {
            console.log(&#096;Pokemon Name: &#036;{data.name}&#096;);
          })
          .catch(err => console.error(&#096;An error occurred: &#036;{err.message}&#096;))
          .finally(() => console.log(&#096;Pokemon request completed.&#096;));

          // Output: 
          // An error occurred: Pokemon not found (status: 404)
          // Pokemon request completed.
    </code></pre>
    <h4>Error handling using .catch() with async/await</h4>
    <pre><code class="language-javascript">
        async function fetchData() {
          return await Promise.reject(new Error("Something went wrong!")); 
        }

        fetchData()
          .then(data => console.log("Data received:", data))
          .catch(error => console.log("Caught error:", error.message));
    </code></pre>
    <h3>Handling rejected promises with async/await in a try-catch</h3>
    <div class="info">
      When using <b>async/await</b>, errors (eg. rejected promises) can be caught using a <b>try-catch</b> block
    </div>
    <pre><code class="language-javascript">
        const getPokemonData = async function (pokemon) {
          try {
            const res = await fetch(&#096;https://pokeapi.co/api/v2/pokemon/&#036;{pokemon}&#096;);

            if (!res.ok) 
            throw new Error(&#096;Pokemon not found (status: &#036;{res.status})&#096;);

            const data = await res.json();
          } catch (err) {
            console.error(&#096;An error occurred: &#036;{err.message}&#096;);
          } finally {
            console.log('Request completed.');
          }
        };

        getPokemonData('unknown-pokemon');    
    </code></pre>
    <h3>Async function promise rejection</h3>
    <div class="info">
    When an error or a rejected promise occurs inside an async function, the function still returns a promise instead of throwing an error. The internal value of the Promise will be the thrown error
    </div>
    <pre><code class="language-javascript">
        /* This example illustrates that no matter what happens inside an async function,
        it will always return a promise */

        const fetchPokemonData = async (pokemon) => {
          throw new Error(&#096;Something went wrong while fetching &#036;{pokemon}&#096;);
        };

        /* Without 'await' the entire Promise is retrieved, not the inner value of the promise.
        This way we can inspect the Promise object */
        const result = fetchPokemonData('pikachu');

        console.log(result); 
        // Output:
        // Promise rejected: Error: Something went wrong while fetching pikachu
          
        // Using a .catch() retrieves the inner Promise value (the error)
        result.catch(err => console.error(&#096;Caught error: &#036;{err.message}&#096;));
        // Output: Caught error: Something went wrong while fetching pikachu
    </code></pre>
    <div class="info">
    If the error is not re-thrown, the promise will <b>resolve successfully</b>, which might lead to unexpected behavior
    </div>
    <pre><code class="language-javascript">
        /* This fetch will give us a 404, which is thrown and caught inside the asyn function
        However since we don't rethrow it, and an async function always returns a promise,
        it will be a resolved promise */

        const fetchPokemonData = async (pokemon) => {
          try {
            const res = await fetch(&#096;https://pokeapi.co/api/v2/pokemon/&#036;{pokemon}&#096;);
            if (!res.ok) throw new Error(&#096;Pokemon not found (status: &#036;{res.status})&#096;);
            const data = await res.json();
            return data;
          } catch (err) {
            console.error(&#096;Caught error: &#036;{err.message}&#096;);
            // The error is not rethrown here
          }
        };

        fetchPokemonData('unknown-pokemon')
          .then(data => {
            console.log(&#096;Function resolved successfully! Data: &#036;{JSON.stringify(data)}&#096;);
          })
          .catch(err => {
            console.error(&#096;This will not be called because the promise resolved successfully&#096;);
          });
          // Output: Function resolved successfully! Data: undefined
    </code></pre>
    <h4>Correct way to handle a rejected promise</h4>
    <pre><code class="language-javascript">
        const getPokemonData = async function (pokemon) {
        try {
          const res = await fetch(&#096;https://pokeapi.co/api/v2/pokemon/&#036;{pokemon}&#096;);

          if (!res.ok) 
            throw new Error(&#096;Pokemon not found (&#036;{res.status})&#096;);

          const data = await res.json();
        } catch (err) {
          console.error(&#096;An error occurred: &#036;{err.message}&#096;);
          throw err; 
          // Re-throw the error to propagate it
        }
        };

        getPokemonData('unknown-pokemon')
        .then(() => console.log(&#096;Resolved promise&#096;))
        .catch(err => console.error(&#096;Caught error: &#036;{err.message}&#096;));

        // Output:
        // An error occurred: Pokemon not found (404)
        // Caught error: Pokemon not found (404)
    </code></pre>
  </div><!-- end error handling -->

  <div data-id="asynchronous javascript-promisifying">
    <h2>Promisifying</h2>
    <div class="info">
      <ul>
        <li>Promisifying is the process of converting callback-based functions into promise-based functions</li>
        <li>This approach is more readable, more in line with modern async programming, has better error handling, is easier to combine with other async operations, and can avoid nested callbacks</li>
        <li>Promises can then be consumed using <i>.then()</i>, <i>.catch()</i>, and <i>.finally()</i></li>
      </ul>
    </div>
    <h3>Example: Promisifying setTimeout</h3>
    <pre><code class="language-javascript">
        const wait = function (seconds) {
          return new Promise(function (resolve) {
            setTimeout(resolve, seconds * 1000);
          });
        };

        wait(1)
          .then(() => {
            console.log(&#096;1 second passed&#096;);
            return wait(1);
          })
          .then(() => {
            console.log(&#096;2 seconds passed&#096;);
            return wait(1);
          })
          .then(() => {
            console.log(&#096;3 seconds passed&#096;);
            return wait(1);
          })
          .then(() => console.log(&#096;4 seconds passed&#096;));
    </code></pre>
    <h3>Promisifying the Geolocation API</h3>
    <div class="info">
      The Geolocation API's <i>navigator.geolocation.getCurrentPosition</i> uses a successcallback and an errorcallback as parameters. These cbfn's get executued <b>asynchronously</b>.<br>
      This makes this function a great candidate to promisify
    </div>
    <h4>Without promisifying (callback based)</h4>
    <pre><code class="language-javascript">
        const getWeatherData = () => {
          // Get currentPosition accepts a succes cbfn and an error cbfn
          // The succes cbfn gets passed the position object
          navigator.geolocation.getCurrentPosition(
            position => {
              const latitude = position.coords.latitude;
              const longitude = position.coords.longitude;

              fetch(&#096;https://api.weatherapi.com/v1/current.json?key=YOUR_API_KEY&q=&#036;{latitude},&#036;{longitude}&#096;)
                .then(response => {
                  if (!response.ok) {
                    throw new Error(&#096;Failed to fetch weather data (&#036;{response.status})&#096;);
                  }
                  return response.json();
                })
                .then(weatherData => {
                  console.log(&#096;Weather data: &#036;{JSON.stringify(weatherData)}&#096;);
                })
                .catch(err => {
                  console.error(&#096;Error fetching weather data: &#036;{err.message}&#096;);
                });
            },
            err => {
              console.error(&#096;Failed to retrieve position: &#036;{err.message}&#096;);
            }
          );
        };

        getWeatherData();    
    </code></pre>
    <h4>With promisifying </h4>

    <pre><code class="language-javascript">
        /* Get currentPosition accepts a succes cbfn and an error cbfn
          We pass the resolve() and reject() cbfns of our promise constructor to getCurrentPosition()
          This because resolve() and reject() accept a value that will become the Promises' resolved/rejected value. 
          Since getCurrentPosition() passes the position object to it's success cbfn, 
          it will get passed to the resolve() function and become the Promises' internal value.
          Which in turn will be consumed by 'await' */

        const getPosition = () => {
          return new Promise((resolve, reject) => {
            // We store the position object as the Promises' internal value here
            navigator.geolocation.getCurrentPosition(resolve, reject);
          });
        };

        const getWeatherData = async () => {
          try {
            const position = await getPosition(); // We consume the promise here
            const latitude = position.coords.latitude;
            const longitude = position.coords.longitude;
            console.log(&#096;Retrieved position: Latitude &#036;{latitude}, Longitude &#036;{longitude}&#096;);

            const response = await fetch(
              &#096;https://api.weatherapi.com/v1/current.json?key=YOUR_API_KEY&q=&#036;{latitude},&#036;{longitude}&#096;
            );

            if (!response.ok) {
              throw new Error(&#096;Failed to fetch weather data (&#036;{response.status})&#096;);
            }

            const weatherData = await response.json();

            console.log('Weather data:', weatherData);
          } catch (err) {
            console.error(&#096;Error: &#036;{err.message}&#096;);
          }
        };

        getWeatherData();
    </code></pre>
  </div><!-- end promisifying -->

  <div data-id="asynchronous javascript-promise combinators">
    <h2>Promise Combinators</h2>
    <div class="info">
        Promise combinators allow you to work with multiple promises simultaneously
    </div>
    <h3>Promise.all()</h3>
    <div class="info">
      <ul>
      <li><b>Promise.all()</b>  runs multiple promises in parallel and waits for all of them to settle</li>
      <li>It accepts an array of promises as parameter</li>
      <li>If <b>all</b> promises succeed, <i>Promise.all()</i> returns a Promise with it's resolved value set to an array containing all the executed Promise values</li>
      <li>If <b>one promise fails</b>, the entire <i>Promise.all()</i> fails and throws an error</li>
      <li><i>Promise.all()</i> returns a single promise that resolves with an array of results if all promises succeed, or rejects if any promise fails</li>
      <li>Used for async bulk-requests where each Promise has to succeed</li>
      </ul>
    </div>
    <pre><code class="language-javascript">
        const fetchPokemon = (pokemon) => {
          return fetch(&#096;https://pokeapi.co/api/v2/pokemon/&#036;{pokemon}&#096;)
            .then(response => {
              if (!response.ok) throw new Error(&#096;Failed to fetch data for &#036;{pokemon}&#096;);
              return response.json(); // Returns a promise
            });
        };

        const getPokemons = async () => {
          try {
            const pokemons = ['squirtle', 'charmander', 'bulbasaur'];

            // Execute all API calls simultaneously
            const pokemonData = await Promise.all(pokemons.map(fetchPokemon));
            
            console.log("Pokemon data received:", pokemonData);
            
            pokemonData.forEach(pokemon => {
              console.log(&#096;&#036;{pokemon.name.toUpperCase()} 
              - Type: &#036;{pokemon.types.map(t => t.type.name).join(', ')}&#096;);
            });
          } catch (error) {
            console.error("Something went wrong:", error.message);
          }
        };

        getPokemons();
    </code></pre>
    <h3>Promise.allSettled()</h3>
    <div class="info">
      <ul>
        <li><b>Promise.allSettled()</b> works the same as <i>Promise.all()</i> but it does not fail when one promise fails<br> 
        Meaning it <i>always</i> resolves even if some promise fails</li>
        <li>It accepts an array of promises as parameter</li>
        <li>It returns a resolved promise (always) that contains an array with objects that have a 'status' and 'value' property for requested promise</li>
        <li>Used for async bulk-requests where not every request has to succeed</li>
      </ul>
    </div>
    <pre><code class="language-javascript">
        const fetchPokemon = (pokemon) => {
        return fetch(&#096;https://pokeapi.co/api/v2/pokemon/&#036;{pokemon}&#096;)
            .then(response => {
              if (!response.ok) throw new Error(&#096;Pokémon &#036;{pokemon} not found&#096;);
              return response.json(); // Returns a promise
            });
        };

        const getPokemons = async () => {
          try {
            const pokemons = ['squirtle', 'charmander', 'not-a-pokemon']; // One incorrect name
            const results = await Promise.allSettled(pokemons.map(fetchPokemon));

            console.log("Results:", results);

            results.forEach((result, index) => {
              if (result.status === "fulfilled") {
                console.log(&#096;&#036;{pokemons[index].toUpperCase()} - 
                Type: &#036;{result.value.types.map(t => t.type.name).join(", ")}&#096;);
              } else {
                console.error(&#096;&#036;{pokemons[index]} failed: &#036;{result.reason.message}&#096;);
              }
            });

          } catch (error) {
            console.error("An error occured:", error);
          }
        };

        getPokemons();
    </code></pre>
    <h3>Promise.race()</h3>
    <div class="info">
      <ul>
        <li><b>Promise.race()</b> waits for the first promise to settle (either fulfilled or rejected) and immediately resolves or rejects with that result</li>
        <li>It accepts an array of promises as parameter</li>
        <li>It returns a promise that resolves or rejects as soon as the first promise in the array settles</li>
        <li>Useful for scenarios where you want the fastest response, such as loading the quickest API or setting a timeout</li>
      </ul>
    </div>
    <pre><code class="language-javascript">
        const fetchPokemon = (pokemon) => {
          return fetch(&#096;https://pokeapi.co/api/v2/pokemon/&#036;{pokemon}&#096;)
            .then(response => {
              if (!response.ok) throw new Error(&#096;Pokémon &#036;{pokemon} not found&#096;);
              return response.json(); // Returns a promise
            });
        };

        // Simulate a timeout to prevent waiting too long
        const timeout = (ms) => {
          return new Promise((_, reject) =>
            setTimeout(() => reject(new Error("Request timed out!")), ms)
          );
        };

        const getFastestPokemon = async () => {
          try {
            const pokemons = ['squirtle', 'charmander', 'bulbasaur'];
            
            // Start race between API requests and a timeout
            const result = await Promise.race([
              ...pokemons.map(fetchPokemon),
              timeout(3000) // If none respond in 3 seconds, reject
            ]);

            console.log(&#096;Fastest request retrieved: &#036;{result.name.toUpperCase()} 
            - Type: &#036;{result.types.map(t => t.type.name).join(', ')}&#096;);

          } catch (error) {
            console.error("Error:", error.message);
          }
        };

        getFastestPokemon();
    </code></pre>

    <h3>Promise.any()</h3>
    <div class="info">
      <ul>
        <li><b>Promise.any()</b> waits for the <b>first successfully fulfilled promise</b> and returns its value</li>
        <li>It is similar to Promise.race(), but ignores rejected promises</li>
        <li>It accepts an array of promises as a parameter</li>
        <li>If <b>one</b> promise succeeds, the returned promise resolves with that value</li>
        <li>If <b>all</b> promises fail, it throws an <i>AggregateError</i> containing all errors</li>
        <li>Useful in scenarios where you only need one successful response, such as failover mechanisms between multiple APIs</li>
      </ul>
    </div>
    <pre><code class="language-javascript">
        const fetchPokemon = (pokemon) => {
          return fetch(&#096;https://pokeapi.co/api/v2/pokemon/&#036;{pokemon}&#096;)
            .then(response => {
              if (!response.ok) throw new Error(&#096;Failed to fetch data for &#036;{pokemon}&#096;);
              return response.json(); // Returns a promise
            });
        };

        // Simulate a failure for some API requests
        const unreliableFetch = (pokemon) => {
          return new Promise((resolve, reject) => {
            if (Math.random() > 0.5) {
              resolve(fetchPokemon(pokemon));
            } else {
              reject(new Error(&#096;&#036;{pokemon} request failed!&#096;));
            }
          });
        };

        const getAnyPokemon = async () => {
          try {
            const pokemons = ['squirtle', 'charmander', 'bulbasaur', 'not-a-pokemon'];

            // Wait for the first successful response
            const firstSuccess = await Promise.any(pokemons.map(unreliableFetch));

            console.log(&#096;First successful request: &#036;{firstSuccess.name.toUpperCase()} 
            - Type: &#036;{firstSuccess.types.map(t => t.type.name).join(', ')}&#096;);

          } catch (error) {
            if (error instanceof AggregateError) {
              console.error("All requests failed:", error.errors.map(e => e.message));
            } else {
              console.error("Unexpected error:", error.message);
            }
          }
        };

        getAnyPokemon();
    </code></pre>

  </div> <!-- end promise combinators -->

  <div data-id="asynchronous javascript-top level await">
    <h2>Top Level Await</h2>
    <div class="info">
      <ul>
        <li><b>Top level await</b> allows the use of the <b>await</b> keyword outside of an <i>async</i> function</li>
        <li>It can only be used in JavaScript modules &lt;script type="module"&gt;</li>
        <li>Top level await <b>pauses the execution of the entire module</b> until the awaited promise is settled</li>
      </ul>
    </div>
    <pre><code class="language-javascript">
        const getLastPost = async function () {
          const res = await fetch(&#096;https://jsonplaceholder.typicode.com/posts&#096;);
          const data = await res.json();
          return { title: data.at(-1).title, text: data.at(-1).body };
        };

        // Using top level await
        const lastPost = await getLastPost();
        console.log(lastPost);
    </code></pre>
    <h3>Using Top Level Await in Imported Modules</h3>
    <div class="info">
      <p>When an imported module uses top level await, it blocks the execution of the importing module until the awaited promise is settled.</p>
    </div>
    <pre><code class="language-javascript">
        // module1.js
        export const data = await fetch(&#096;https://api.example.com/data&#096;).then(res => res.json());

        // module2.js
        import { data } from &#096;./module1.js&#096;;
        console.log(data); // Execution is blocked until module1.js resolves its await
    </code></pre>
  </div><!-- end top level await -->
</div><!-- end asynchronous javascript -->

<div data-id="javascript-modules" class="level1-container">
  <h1>Modules</h1>

    <h2>What are modules?</h2>
    <div class="info">
      Modules allow JavaScript to split code into separate files, making it more manageable and reusable.
      <ul>
        <li><b>Importing a module</b> is called a <i>dependency</i></li>
        <li><b>Exporting a module</b> defines the <i>public API</i> of that module</li>
        <li>Imported values are <b>references</b>, not copies. Changes in the importing module affect the exporting module</li>
        <li>Imports are <b>hoisted</b> and executed before the importing file runs</li>
        <li>Modules are in <b>strict mode</b> by default</li>
      </ul>
  </div> 

  <h2>ES6 Modules</h2>
  <div data-id="modules-es6 modules">
    <div class="info">
      To use ES6 modules in the browser, set the script type to "module".
      <ul>
      <li>Scripts with <b>type="module"</b> are <b>automatically deferred</b>, so the 'defer' keyword is optional</li>
      <li>Using module bundlers (e.g., Webpack, Parcel) remove the need for the 'module' attribute because they pack everything in a single file anyway</li>
    </ul>
    </div>
    <pre><code class="language-html">
    &lt;script defer type="module" src="script.js"&gt;&lt;/script&gt;
    </code></pre>
  </div>

  <h3>Named exports</h3>
  <div data-id="modules-named and default exports">
    <div class="info">
      Named exports allow exporting multiple values from a module.
    </div>

    <h4>Exporting and importing named values</h4>
    <pre><code class="language-javascript">
        // myModule.js
        export const myFunction = function() { return 1; };
        export const myVariable = 42;

        // main.js
        import { myFunction, myVariable } from &#096;./myModule.js&#096;;
        console.log(myFunction()); // Output: 1
        console.log(myVariable);   // Output: 42
    </code></pre>

    <h4>Renaming Exports and Imports</h4>
    <pre><code class="language-javascript">
        // Export with alias
        export { myFunction as renamedFunction };

        // Import with alias
        import { renamedFunction as newFunction } from &#096;./myModule.js&#096;;
    </code></pre>

    <h4>Importing everything</h4>
    <pre><code class="language-javascript">
        // myModule.js
        export const myFunction = function() { return 1; };
        export const myVariable = 42;

        import * as MyModule from &#096;./myModule.js&#096;;
        console.log(MyModule.myFunction()); // Output: 1
        console.log(MyModule.myVariable); // Output: 42
    </code></pre>

    <h3>Default Exports</h3>
    <div class="info">
      A default export is used when there is one main functionality in the module.<br> A module can have only one default export. The importing file can choose any name for it.
    </div>
    <h4>Default export</h4>
    <pre><code class="language-javascript">
        export default function(var1) {
          console.log(var1);
        }
    </code></pre>
    <h4>Importing Default Exports</h4>
    <pre><code class="language-javascript">
        import anyName from &#096;./myModule.js&#096;;
        anyName('Hello'); // Output: Hello
    </code></pre>

    <h3>ES6 exporting/importing examples</h3>
    <h4>Multiple functions and variables</h4>
    <pre><code class="language-javascript">
        /* Named exports allow exporting multiple functions and variables from a module. */

        // math.js (ES6)
        export function add(a, b) {
          console.log(a + b);
        }
        
        export function subtract(a, b) {
          console.log(a - b);
        }

        export const username = "Matthias";
        
        // main.js
        import { add, subtract, username } from "./math.js";
        
        add(5, 3); // Output: 8
        subtract(5, 3); // Output: 2
        console.log(username); // Output: Matthias
    </code></pre>

    <h4>Exporting and importing a class</h4>
    <pre><code class="language-javascript">
        /* You can export a class as the default export of a module. */

        // Car.js (ES6)
        export default class Car {
          constructor(brand) {
            this.brand = brand;
          }

          drive() {
            console.log(&#096;&#036;{this.brand} is driving!&#096;);
          }
        }

        // main.js
        import Car from "./Car.js";

        const myCar = new Car("Toyota");
        myCar.drive(); // Output: Toyota is driving!
    </code></pre>

    <h4>Mixing default exports and names exports</h4>
    <pre><code class="language-javascript">
        // shapes.js (ES6)
        export default function circleArea(radius) {
          return Math.PI * radius * radius;
        }
        
        export function squareArea(side) {
          return side * side;
        }
        
        // main.js
        import circleArea, { squareArea } from "./shapes.js";
        
        console.log(circleArea(5));  // Output: 78.5398
        console.log(squareArea(4));  // Output: 16    
    </code></pre>
  </div> <!-- end exports -->

  <h2>CommonJS Modules</h2>
  <div data-id="modules-commonjs modules">
    <div class="info">
      CommonJS modules are an older way of importing/exporting.<br>
      They are used in Node.js but not recognized by browsers.<br>Node.js requires a server to run on, it does not run in the browser.
    </div>
    <h3>Using CommonJS by overwriting module.exports object</h3>
    <pre><code class="language-javascript">
        /* By overwriting module.exports you can only export one value.
        (Eg. an object, a class, a function..) */

        // helpers.js (CommonJS)
        module.exports = function() {
          console.log('Hello');
        };

        // main.js
        const myFunction() = require(&#096;./helpers.js&#096;);
        myFunction(); // Output: Hello
    </code></pre>

    <pre><code class="language-javascript">
        // Car.js (CommonJS)
        class Car {
          constructor(brand) {
            this.brand = brand;
          }
        
          drive() {
            console.log(&#096;&#036;{this.brand} is driving!&#096;);
          }
        }

        module.exports = Car;

        // main.js (CommonJS)
        const Car = require('./Car');

        const myCar = new Car("Toyota");
        myCar.drive(); // Output: Toyota is driving!
    </code></pre>

    <h3>Using CommonJS by using module.exports properties</h3>
    <pre><code class="language-javascript">
        // helpers.js
        module.exports.sayHello = () => console.log('Hello');
        module.exports.pokemon = 'pikachu';
        // You can use 'exports' for short aswell
        exports.username = 'Matthias';

        // main.js
        const helpers = require('./helpers.js');

        helpers.sayHello(); // Output: Hello
        console.log(helpers.pokemon); // Output: pikachu
        console.log(helpers.username); // Output: Matthias
    </code></pre>

  </div> <!-- end commonjs -->
</div> <!-- end modules -->


<div data-id="javascript-this keyword" class="level1-container">
  <h1>'this' keyword</h1>

  <div data-id="this keyword-overview">
  <h2>Overview</h2>
  <table>
    <thead>
        <tr>
            <th>Context</th>
            <th>this Keyword</th>
        </tr>
    </thead>
    <tbody>
        <tr>
            <td>Global scope<br>Standalone functions<br>(non-strict mode)</td>
            <td>window (browser) / global (Node.js)</td>
        </tr>
        <tr>
            <td>Global scope<br>Standalone functions<br>(strict mode)</td>
            <td>undefined</td>
        </tr>
        <tr>
            <td>Method calls</td>
            <td>Refers to the calling object</td>
        </tr>
        <tr>
            <td>Arrow functions</td>
            <td>Lexically inherited from the surrounding scope</td>
        </tr>
        <tr>
            <td>Constructors and classes</td>
            <td>Refers to the newly created instance</td>
        </tr>
        <tr>
            <td>Event listeners</td>
            <td>
                - Regular function: Refers to the DOM element <br>
                - Arrow function: Lexically inherited (often window or undefined in strict mode)
            </td>
        </tr>
    </tbody>
  </table>



  <h3>Global scope and standalone functions (non-strict mode)</h3>
    <div class="info">
      In non-strict mode (without 'use strict'), 
       <b>this</b> in the global scope and standalone functions (functions that are not in an object or class) refer to:
       <ul>
       <li>the <b>global window object</b> (in the browser)</li>
       <li>the <b>global object</b> (in Node.js)</li>
       </ul>
    </div>
    <pre><code class="language-javascript">
        // Non-strict mode standalone function
        function showThis() {
          console.log(this); // Output: window
        }
        
        showThis();

        // Non-strict mode global scope
        console.log(this); // Output: window
    </code></pre>


    <h3>Global scope and standalone function (strict mode)</h3>
    <div class="info">
      In <b>strict mode</b> ('use strict'), the default value of <b>this</b> in the global scope and regular function calls is <i>undefined</i>.
    </div>
    <pre><code class="language-javascript">
        'use strict';

        // Strict mode standalone function
        function showThis() {
          console.log(this); // Output: undefined
        }

        showThis();

        // Strict mode global scope
        console.log(this); // Output: undefined
    </code></pre>

    <h3>Method calls</h3>
    <div class="info">
      When a method on an object is called, <b>this</b> inside the method refers to the calling object
    </div>
    <pre><code class="language-javascript">
        const pokemon = {
          name: 'Pikachu',
          type: 'Electric',
          showDetails() {
            console.log(this); // 'this' refers to the 'pokemon' object
            console.log(&#096;&#036;{this.name} is a &#036;{this.type}-type Pokémon!&#096;);
            /* Notice that 'this' is necessary here because name and type do not
            exist inside the method's scope */
          }
        };

        pokemon.showDetails();
        // Output:
        // { name: 'Pikachu', type: 'Electric', showDetails: [Function: showDetails] }
        // "Pikachu is a Electric-type Pokémon!"    
    </code></pre>

    <h3>Arrow functions</h3>
    <div class="info">
      <ul>
        <li>Arrow functions do <b>not</b> have their own &#096;this&#096;; they capture the &#096;this&#096; value from the outer (lexical) scope.</li>
        <li>This means that &#096;this&#096; in an arrow function usually matches the &#096;this&#096; in the surrounding code.</li>
      </ul>
    </div>
    <pre><code class="language-javascript">
        const pokemonTrainer = {
          name: &#096;'Ash'&#096;,
          friends: [&#096;'Misty'&#096;, &#096;'Brock'&#096;],
          showFriends: function() {
            /* this.friends is necessary here because friends does not exist in the method's scope
            'this' is equal to the calling object inside this method */
            this.friends.forEach(friend => {
              /* Inside the arrow function, 'this' is the same as 'this' in 
              it's outer scope (showFriends). So it refers to the calling method aswell*/
              console.log(&#096;&#036;{this.name} is friends with &#036;{friend}&#096;);
            });
          }
        };

        pokemonTrainer.showFriends();
        // The arrow function takes the 'this' value from showFriends(), so it refers to 'pokemonTrainer'
    </code></pre>

    <h3>Constructors and classes</h3>
    <div class="info">
      <ul>
        <li>Inside a constructor, <b>this</b> refers to the newly created instance</li>
        <li>Inside a class, <b>this</b> refers to the calling object</li>
      </ul>
    </div>
    <pre><code class="language-javascript">
        class Pokemon {
          constructor(name, type) {
            // Stores these values inside the newly created object
            this.name = name; 
            this.type = type;
            console.log(this); // Newly created instance
          }

          describe() {
            console.log(this); // Calling object
            console.log(&#096;This Pokemon is &#036;{this.name}, type: &#036;{this.type}.&#096;);
          }
        }

        const bulbasaur = new Pokemon(&#096;'Bulbasaur'&#096;, &#096;'Grass/Poison'&#096;);
        bulbasaur.describe(); 

        /* Output : 
        Pokemon { name: 'Bulbasaur', type: 'Grass/Poison' }
        Pokemon { name: 'Bulbasaur', type: 'Grass/Poison' }
        This Pokemon is Bulbasaur, type: Grass/Poison. */
    </code></pre>

    <h3>Event listeners</h3>
    <div class="info">
      <ul>
        <li>In DOM event listeners (using a non-arrow function), <b>this</b> often refers to the DOM element on which the event listener was placed</li>
        <li>If you use an arrow function it will adopt 'this' from the outer scope</li>
      </ul>
    </div>
    <pre><code class="language-javascript">
        // Example in a browser context:
        const button = document.querySelector('button');

        // 'this' points to the button element in a regular function
        button.addEventListener('click', function() {
          console.log(this); 
          // Output : < button >...< /button>
        });
        
        // 'this' is lexically taken from outside scope 
        // (often window or undefined in strict mode)
        button.addEventListener('click', () => {
          console.log(this); 
        });
    </code></pre>
  </div>
  <div data-id="this keyword-method borrowing">
    <h2>Method borrowing</h2>
    <div class="info">
    Methods that use the 'this' keyword can borrowed by other objects
    </div>
    <pre><code class="language-javascript">
        const pikachu = {
          name: 'Pikachu',
          level: 25,
          attack: function () {
            console.log(this);
            console.log(&#096;&#036;{this.name} attacks with Slash at level &#036;{this.level}!&#096;);
          },
        };

        pikachu.attack(); 
        // Output:
        // { name: 'Pikachu', level: 25, attack: [Function: attack] }
        // "Pikachu attacks with Slash at level 25!"

        const charmander = {
          name: 'Charmander',
          level: 18,
        };

        // Method Borrowing: Charmander "borrows" Pikachu's attack method
        charmander.attack = pikachu.attack;

        charmander.attack();  
        // Output:
        // { name: 'Charmander', level: 18, attack: [Function: attack] }
        // "Charmander attacks with Slash at level 18!"
    </code></pre>
  </div>

  <h2>Function binding</h2>
  <div data-id="this keyword-function binding">
    <div class="info">
      <ul>
        <li><b>call()</b> and <b>apply()</b> immediately invoke a function with an explicit <b>this</b> binding</li>
        <li>The only difference between call() and apply() is that <b>call()</b> accepts individual arguments, while <b>apply()</b> expects an array of arguments</li>
      </ul>
    </div>

    <h3>call()</h3>
    <pre><code class="language-javascript">
        const trainerUtils = {
          introduceTrainer: function (city, pokemon) {
            console.log(&#096;Hello, I'm &#036;{this.name} from &#036;{city}.&#096;);
            console.log(&#096;My specialty is &#036;{this.specialty}, and my main Pokémon is &#036;{pokemon}!&#096;);
          }
        };

        const trainerA = {
          name: 'Ash',
          specialty: 'Electric-type Pokémon'
        };

        const trainerB = {
          name: 'Brock',
          specialty: 'Rock-type Pokémon'
        };

        trainerUtils.introduceTrainer.call(trainerA, 'Pallet Town', 'Pikachu');
        // Output :
        // "Hello, I'm Ash from Pallet Town."
        // "My specialty is Electric-type Pokémon, and my main Pokémon is Pikachu!"

        trainerUtils.introduceTrainer.call(trainerB, 'Pewter City', 'Onix');
        // Output :
        // "Hello, I'm Brock from Pewter City."
        // "My specialty is Rock-type Pokémon, and my main Pokémon is Onix!"
    </code></pre>

    <h3>apply()</h3>
    <pre><code class="language-javascript">
        function introducePokemon(region, starter) {
          console.log(&#096;Trainer &#036;{this.name} comes from &#036;{region} and starts with &#036;{starter}.&#096;);
        }

        const trainer = { name: 'Brock' };

        introducePokemon.apply(trainer, ['Pewter City', 'Geodude']);
        // Output: "Trainer Brock comes from Pewter City and starts with Geodude."
    </code></pre>

    <h3>bind()</h3>
    <div class="info">
      <b>bind()</b> returns a <u>new</u> function that permanently binds <b>this</b> without invoking it immediately
    </div>
    <pre><code class="language-javascript">
        class Pokemon {
          constructor(name, type) {
            this.name = name;
            this.type = type;
          }

          useMove(move) {
            console.log(&#096;&#036;{this.name} used &#036;{move}! It's a &#036;{this.type}-type attack!&#096;);
          }

          startBattle() {
            console.log(&#096;&#036;{this.name} is ready for battle!&#096;);
            setTimeout(this.useMove.bind(this, "Thunderbolt"), 2000);

            /* The first this in 'this.useMove' is necessary because otherwise 
            we would get an uncaught referenceError: 'useMove is not defined'
            This is because useMove() is a method of the Pokemon class.
            It should be called as a method on the calling object */

            /* The second this in 'bind(this, "Thunderbolt") is necessary because otherwise
            'this' would refer to 'window' (or undefined in strict)
            This is because the setTimeoutFunction executes its callback 
            as a standalone function */

            /* 'call()' and 'apply()' would also work, but they immediately execute 
            the function instead of returning a new one like 'bind()' does.
            To ensure 'useMove' is only executed after 2 seconds, 
            it must be wrapped inside a callback function:
            Eg. setTimeout(() => this.useMove.call(this, "Thunderbolt"), 2000); */
          }
        }

        const pikachu = new Pokemon("Pikachu", "Electric");
        pikachu.startBattle();      
    </code></pre>
  </div>

</div><!-- end this keyword container -->

<div data-id="javascript-behind the scenes" class="level1-container">
  <h1>JavaScript Behind the Scenes</h1>
  Gifs created from &copy; <a href="https://www.jsv9000.app/" target="_blank" rel="noopener noreferrer">jsv9000</a>

  <div data-id="behind the scenes-the callstack">
    <h2>Call Stack</h2>
    <div class="info">
    <ul>
    <li>Keeps track of the currently executing functions</li>
    <li>The call stack executes functions in a LIFO (Last In, First Out) manner</li>
    </ul>
    </div>

    <img src="${callstackgif}" alt="Callstack animation" class="responsive-gif">

  </div>


  <div data-id="behind the scenes-the callback queue">
  <h2>Callback or task queue</h2>

  <div class="info">
    <ul>
    <li>The callback/task Queue holds non-promise related async callbacks (eg. timer, click events, ..)</li>
    <li>It is a FIFO queue of tasks that are going to be executed by the Event Loop</li>
    </ul>
  </div>

  <img src="${callbackqueue}" alt="Callbackqueue animation" class="responsive-gif">
  </div>

  <div data-id="behind the scenes-the microtask queue">
  <h2>Microtask Queue</h2>
    <div class="info">
    <ul>
    <li>The microtasks queue holds the callbacks that are related to Promises and their .then()</li>
    <li>The microtask queue has <b>priority</b> over the callback queue</li>
    <li>All microtasks will be resolved before continuing the event loop</li>
    </ul>
    </div>

    <pre><code class="language-javascript">
        /* The timer will resolve after the promise
        even though it is set to 0. Because the microtask queue has priority.
        This can cause timers to execute even later than their given time! */

        console.log('Test start');
        setTimeout(() => console.log('0 sec timer'), 0);
        Promise.resolve('Resolved promise 1').then(res => console.log(res));
        console.log('Test end');
    </code></pre>

    <img src="${microtaskqueue}" alt="Microtaskqueue animation" class="responsive-gif">
  </div>

  <div data-id="behind the scenes-the event loop">
    <h2>Event Loop</h2>
    <div class="info">
    <ol>
    <li>The script is executed synchronously until the callstack is empty</li>
    <li>If the callstack is empty, the event loop takes the first task from the callback queue and adds it to the callstack for execution</li>
    <li>The callback queue task runs until the callstack is empty</li>
    <li>Next, the event loop will run ALL microstasks, starting from the oldest one</li>
    <li>The event loop reruns constantly through the taskqueue and the microtask queue (prioritising the microtask queue)</li>
    </ol>
    </div>
  </div>

  <div data-id="behind the scenes-hoisting">

    <h2>Hoisting</h2>

    <div class="info">
    <ul>
      <li>Hoisting makes some types of variable and function declarations usable in the code before they are declared</li>
      <li>variables are lifted to the top of their scope</li>
    </ul>
    </div>

    <table>
    <thead>
      <tr>
        <th>Declaration Type</th>
        <th>Hoisted?</th>
        <th>Initialization?</th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td>var (variables)</td>
        <td>Yes</td>
        <td>Undefined</td>
      </tr>
      <tr>
        <td>let / const <br>(variables, function expressions, arrow functions)</td>
        <td>Yes</td>
        <td>Not initialized (Temporal Dead Zone)</td>
      </tr>
      <tr>
        <td>Function Declarations</td>
        <td>Yes</td>
        <td>Fully hoisted</td>
      </tr>
    </tbody>
  </table>
  

    <h3>Hoisting with var</h3>
    <div class="info">
      Variables declared with 'var' are hoisted to the top of their scope and initialized as 'undefined'.
    </div>
    <pre><code class="language-javascript">
      console.log(name); // Output: undefined
      var name = 'Pikachu';
      console.log(name); // Output: Pikachu
    </code></pre>

    <h3>Hoisting with let and const</h3>
    <div class="info">
      <ul>
        <li><b>Variables</b>, <b>function expressions</b> and <b>arrow functions</b> declared with let and const are hoisted but not initialized</li>
        <li>Accessing them before their declaration results in a <b>ReferenceError</b></li>
        <li>These variables are in the <b>Temporal Dead Zone</b> from the start of the sceop until the line where they are defined</li>
      </ul>
    </div>
    <pre><code class="language-javascript">
        // Variables
        console.log(type); // ReferenceError: Cannot access 'type' before initialization
        let type = 'Electric';

        console.log(level); // ReferenceError: Cannot access 'level' before initialization
        const level = 25;

        // Function expressions
        console.log(useMove); // ReferenceError
        let useMove = function () {
          console.log("Charmander used Flamethrower!");
        };

        console.log(specialMove); // ReferenceError
        const specialMove = () => console.log("Mewtwo used Psystrike!");

        // Arrow functions
        console.log(attack); // ReferenceError
        let attack = () => console.log("Pikachu used Thunderbolt!");  
    </code></pre>

    <h3>Hoisting with Function Declarations</h3>
    <div class="info">
      Function declarations are fully hoisted, meaning they can be called before they are defined.
    </div>
    <pre><code class="language-javascript">
        greet(); // Output: "Hello, Trainer!"

        function greet() {
          console.log("Hello, Trainer!");
        }
    </code></pre>
        
  </div> <!-- end hoisting -->

  <div data-id="behind the scenes-scoping">
    <h2>Scoping</h2>
    <div class="info">
    JavaScript has three types of scope:  
    <ul>
      <li><b>Global Scope:</b> Variables declared outside any function or block are accessible everywhere in the code.</li>
      <li><b>Function Scope:</b> Variables declared with var inside a function are only accessible within that function.</li>
      <li><b>Block Scope:</b> Variables declared with let or const inside a block {} are only accessible within that block.</li>
    </ul>
    </div>

    <h3>Let and Const are block-scoped</h3>
    <div class="info">
      When you declare a variable using let or const, it is confined to the block {} where it is declared.<br>
      This means it cannot be accessed outside that block.
    </div>
    <pre><code class="language-javascript">
        if (true) {
          let x = 10;
          const y = 20;
        }
        console.log(x); // ReferenceError: x is not defined
        console.log(y); // ReferenceError: y is not defined 
    </code></pre>

    <h3>Var is function-scoped</h3>
    <div class="info">
      Var is function-scoped, meaning it is only accessible inside the function (or global scope) where it is declared, even if defined inside a block.
    </div>
    <pre><code class="language-javascript">
        // Even though z was declared inside the if block,
        // it is still accessible outside because var does not recognize block scope

        if (true) {
            var z = 30;
        }
        console.log(z); // Works! Output: 30  
    </code></pre>

    <h3>Objects do not create a scope</h3>
    <div class="info">
      An object in JavaScript is just a collection of key-value pairs. It does not create a new execution scope like functions do.<br>
      This is the reason why the 'this' keyword inside an arrow function in an object refers to the global scope<br>
      The object itself does not have a scope, it is only a container, so 'this' takes the surrounding scope.
    </div>
    <pre><code class="language-javascript">
        const obj = {
            name: "Pikachu",
            move: function() {
                console.log(this.name); // 'this' refers to obj
            }
        };
        obj.move(); // Output: Pikachu

        const obj1 = {
          name: "Pikachu",
          move: () => {
              console.log(this.name);
          }
        };
        obj1.move(); // Output: undefined
    </code></pre>
  </div>

</div><!-- end javascript behind the scenes container -->

<div data-id="javascript-extra" class="level1-container">
  <div data-id="extra-glossary">

    <h1>Glossary</h1>

      <table class="glossary-table">
        <tr><td>Ajax</td><td>synchronous javascript and xml. AJAX refers to getting data from a server asynchronously with js or xml. Specifically this means the XMLHttpRequest() and fetch() functions</td></tr>
        <tr><td>Arguments keyword (deprecated)</td><td>Keyword used in JS that holds the arguments passed to the function</td></tr>
        <tr><td>Arguments vs Parameters</td><td>Arguments are the values we pass into a function. Parameters are the values a function accepts</td></tr>
        <tr><td>Array like structure</td><td>Some objects are array-like structures that are iterable (they have a defined length and indexed access), but they are not arrays. Eg. the nodelist returned from document.querySelectorAll(). To convert these to a real array you need to use Array.from()</td></tr>
        <tr><td>Boxing</td><td>Javascript automatically converts primitive values to objects when methods are called on it. Eg. 'thisisastring'.slice(), the string is primitive but we can still call methods on it because JS turns it into an object behind the scene's. Like new String('thisisastring').slice</td></tr>
        <tr><td>Building</td><td> Building refers to the complete process that transforms the source code into a final deliverable, typically including: 
        <ul>
        <li>Compiling (translating the source code to machine code)</li>
        <li>Linking (combining compiled code with libraries)</li>
        <li>Minifying (reducing file size by removing unnecessary characters or code)</li>
        <li> Transpiling (converting code from one language to another, such as TypeScript to JavaScript)</li>
        <li>Bundling (combining multiple files into one, as in JavaScript development with Webpack)</li>
        <li>Packaging (creating installable or distributable files, like .jar files in Java or .exe in Windows)</li>
        </ul></td></tr>
        <tr><td>Callback function</td><td>A function passed into another function as an argument, often used for asynchronous operations.</td></tr>
        <tr><td>Callback queue</td><td>A queue that holds asynchronous tasks (e.g., events like 'click') until they can be executed.</td></tr>
        <tr><td>Callstack</td><td>Tracks currently executing functions. The event loop manages execution order based on the callstack and callback queue.</td></tr>
        <tr><td>Event delegation</td><td>Adding an eventListener to a common parent to handle events that occur on all the child elements (see event propagation), followed by determining which child triggered the event (eg. by checking a common class)</td></tr>
        <tr><td>Event propagation</td><td>The way in which events travel through elements, this happens in 3 phases: 
          <ol>
            <li>Capturing phase: When events occur they are always captured at the root of the DOM, namely the 'document'. After that they travel down through all the parent elements of the element the event was triggered on</li>
            <li>Target phase: The event has reached the element it was triggered on. Here any eventListeners execute their eventHandler</li>
            <li>Bubbling phase: The event travels back through the parent elements of the element the event was trigger on, to the root level (document) This means that the element in 'e.target' in the eventhandler will be the same for the element the event was initiated on, but also for all of it's parent elements</li>
          </ol>
        </td></tr>
        <tr><td>Execution context</td><td>The environment in which JavaScript code is executed, including the global execution context and function execution contexts.</td></tr>
        <tr><td>Expression vs Statement</td><td>An expression is any valid unit of code that resolves to a value. Eg.  5, hello, myFunction(), (x > 5).<br>A statement is a complete line of code that performs some action. Eg let nr = 5; function greet(name) {); for-loops</td></tr>
        <tr><td>Falsy values</td><td>
          <ul>
            <li>false: The boolean value false is explicitly falsy</li>
            <li>Empty strings: An empty string ("") is falsy</li>
            <li>0: The number zero is falsy</li>
            <li>NaN: Not-a-Number (NaN) is falsy</li>
            <li>null: The special keyword null is falsy</li>
            <li>undefined: The special keyword undefined is falsy</li>
            <li>Empty arrays: An array with no elements is falsy</li>
            <li>Empty objects: An object with no properties is falsy</li>
          </ul>
        </td></tr>
        <tr><td>First class functions</td><td>Means the programming language uses functions as if they were values. Functions are just another type of 'object'</td></tr>
        <tr><td>First-class functions</td><td>Functions are treated as values and can be assigned to variables, passed as arguments, or returned from other functions.</td></tr>
        <tr><td>Functional programming</td><td>Declarative programming paradigm based on no side-effects, pure functions and immutability Techniques that tries to avoid data mutations and uses built-in methods that don't produce side effects</td></tr>
        <tr><td>Garbage-collected</td><td>Memory is automatically allocated and deallocated in the JavaScript engine.</td></tr>
        <tr><td>High-level</td><td>Provides abstractions for memory management and execution, unlike low-level languages such as C.</td></tr>
        <tr><td>Higher-order function</td><td>A function that can receive or return another function. Only possible in programming languages that treat functions as first-class functions</td></tr>
        <tr><td>Hoisting</td><td>Makes some variables and functions accessible before their declaration in the code. Function declarations and var variables are hoisted.</td></tr>
        <tr><td>Immutability</td><td>Occurs when state (data) is never modified. Instead state is copied and the copy is mutated and returned</td></tr>
        <tr><td>Imperative and declarative code</td><td>Analogy: imperative is tellings someone to get a mop, make it wet, and whipe te furniture etc. Declarative is telling someone to clean the house.<br>Imperative: step by step explanation about how something should be done.<br>
        Declarative: states what the expected result should be. The logic itself is abstracted away. Use array and object destructuring, use the spread operator, use the ternary operator, use template literals, use filter/map/reduce</td></tr>
        <tr><td>Iterable</td><td>Data structures that can be iterated over, including arrays, strings, maps, and sets. Objects are not iterable by default.</td></tr>
        <tr><td>JS engine</td><td>Parses JavaScript, compiles it to machine code, and executes it.</td></tr>
        <tr><td>JS has no real classes</td><td>'Normal class based inheritance (Java, c#) are defined once and their structure is fixed at compile time. JS uses prototypal inheritance where objects can be linked to other objects</td></tr>
        <tr><td>JS runtime</td><td>A container that includes everything needed to execute JavaScript, including the JS engine, web APIs, and event loop.</td></tr>
        <tr><td>Just-in-time compiled</td><td>Translates code to machine code at runtime for immediate execution, instead of producing a separate binary file.</td></tr>
        <tr><td>Lexical scoping</td><td>Scope is determined by the placement of functions and blocks in the code.</td></tr>
        <tr><td>Lower-level function</td><td>A function that is passed to another function as a value</td></tr>
        <tr><td>Method</td><td>A function that is a property of an object.</td></tr>
        <tr><td>Microtask queue</td><td>The microtasks queue is similar to the callback queue, but it holds the callbacks that are related to Promises. It has priority over the callback queue.</td></tr>
        <tr><td>Multi-paradigm</td><td>JavaScript supports multiple programming paradigms: procedural, object-oriented (OOP), and functional programming (FP).</td></tr>
        <tr><td>Mutate</td><td>Changing the value of a variable after it has been declared.</td></tr>
        <tr><td>Node vs Element</td><td>A node can be anything in the DOM, including comments, etc. An element is always an HTML element</td></tr>
        <tr><td>Nullish values</td><td>null and undefined (not 0 or "")</td></tr>
        <tr><td>Partial application</td><td>A function that has some parameters preset with the bind() method</td></tr>
        <tr><td>Pass by reference vs Passing a reference</td><td>in JS we usually speak of 'passing a reference' instead of 'passing by reference' as is the case in C++ or java. This is because when passing an object to a function in c++, you directly give the function access to the original object. However when passing an object into a function in JS, you give the function a reference to the memorylocation of the object. However the behaviour on the surface will be the same.</td></tr>
        <tr><td>Primitive vs Reference Types</td><td>Primitive types hold their value in the callstack, assigning another value will not influence other primitive types copied from the original (string, number boolean). However reference types (objects) hold their value in the heap (a fixed memory location), assigning another value will influence other reference types copied from the original. This means fe. that primitive values that are passed into a fuction and mutated there will not mutate the original variable, however objects passed into the function and mutated there will also mutate the original object</td></tr>
        <tr><td>Promisifying</td><td>Promisifying is wrapping old(skool) callback based functions into a promise to make them promise based</td></tr>
        <tr><td>Prototype-based object-oriented</td><td>In JS everything besides primitive types (number, string, boolean) are objects (eg arrays). Objects inherit properties and methods from prototype objects rather than from class-based hierarchies.</td></tr>
        <tr><td>Pure function</td><td>A function that does not have any side-effects and does not depend on external variables. Given the same input it 100% of the time returns the same output</td></tr>
        <tr><td>Scope chain</td><td>Inner scopes can access variables from outer scopes but not vice versa.</td></tr>
        <tr><td>Scopes</td><td>JavaScript has global, function, and block scopes. let and const are block-scoped, while var is function-scoped. An object does not create it's own block/scope, it is an object literal. That's why defining an arrow function that uses the 'this' keyword within an object will take the parent scope of the arrow function, which is not the object, but the global scope. (see this keyword).</td></tr>
        <tr><td>Shallow copy</td><td>A copy that has new primitive values, but the objects (arrays, objects, ..) are still referenced to the original. So changes to these objects will reflect in the original. Eg. mutating an object inside a shallow copied array will still mutate the object of the original array</td></tr>
        <tr><td>Side effect</td><td>Any change or observable effect that occurs besides the return statement in a function. This can be modifying global variables or logging something to the console etc.</td></tr>
        <tr><td>Single-threaded / Non-blocking event loop</td><td>JS runs on a single thread but uses an event loop to handle asynchronous tasks without blocking execution.</td></tr>
        <tr><td>TDZ (Temporal Dead Zone)</td><td>The time between when a variable is declared and when it is initialized. Trying to access it results in an error.</td></tr>
        <tr><td>This keyword</td><td>
        <ul>
        <li>Method: this refers to the object calling the method.</li>
        <li>Simple function call: this is undefined in strict mode, otherwise window.</li>
        <li>Arrow functions: this is inherited from the parent scope.</li>
        <li>Event handlers: this refers to the DOM element that the listener is attached to.</li>
        </ul>
        </td></tr>
        <tr><td>Throwaway variable</td><td>A parameter or variable that is in the method signature but is not used. It is replaced with a '_'</td></tr>
        <tr><td>Truthy values</td><td>
        <ul>
        <li>true: The boolean value true is, of course, truthy</li>
        <li>Non-empty strings: Any string with at least one character is considered truthy</li>
        <li>Non-zero numbers: Any numeric value that is not zero is truthy</li>
        <li>Objects: Any non-null object is truthy</li>
        <li>Arrays: Any non-empty array is truthy</li>
        <li>Functions: Any defined function is truthy</li>
        <li>Truthy expressions: Expressions that evaluate to true, for example, 1 + 1 or 5 > 3</li>
        <li>Instances of user-defined classes: If you create a class and instantiate an object from it, the instance is typically truthy</li>
        </ul>
        </td></tr>
        <tr><td>Variable Environment</td><td>The variable environment is part of the execution context and contains all declared variables, function declarations, and their values.</td></tr>
        <tr><td>Web APIs</td><td>Provide functionalities such as DOM manipulation, timers, and fetch API. These are not part of JS but are included in the JS runtime.</td></tr>
      </table>
  </div>


  <div data-id="extra-best practices" class="level1-container">
    <h1>JavaScript Best Practices</h1>

    <h4>Never use an arrow function as a method. But do use it inside a method.</h4>
    <ul>
      <li>When using an arrow function as a method, the <b>this</b> keyword will refer to the global scope (window object) which can introduce bugs (see scope, 'this' and method)</li>
      <li>However, when using a function <em>inside</em> a method it is better to use an arrow function because it uses the scope of the parent (which is the method) and will be able to use the <b>this</b> keyword</li>
    </ul>
    <pre><code class="language-javascript">
          const pikachu = {
            name: &#096Pikachu&#096,
            year: 1996,
            calcPokeAge: function () {
                // console.log(this);
                console.log(2037 - this.year);

                /* Solution 1: Use 'self' or 'that'. This is needed because a regular
                function has it's own 'this' keyword */

                // const self = this;
                // const isGenOne = function () {
                //   console.log(self);
                //   console.log(self.year >= 1981 && self.year <= 1996);
                // };

                /* Solution 2: No 'self' needed because an arrow function does not have it's own 'this' keyword
                and uses that of it's parent (which is the method) */
                const isGenOne = () => {
                    console.log(this);
                    console.log(this.year >= 1981 && this.year <= 1996);
                };
                isGenOne();
            },

            greet: () => {
                console.log(this);
                console.log(&#096Pika! &#036&#123this.name&#125&#096);
            },
        };

        pikachu.greet();
        pikachu.calcPokeAge();
    </code></pre>

    <h4>Never use var</h4>
    <ul>
      <li>
        <b>var</b> is hoisted and initialized as undefined, which can cause bugs
      </li>
    </ul>

    <h4>When working with input strings</h4>
    <ul>
      <li>
        It is common to always convert them to lowercase to start comparing or mutating them.
      </li>
    </ul>

    <h4>The IDE can't infer the type of variables</h4>
    <ul>
      <li>
        So it won't show methods in the intellisense (quick suggestions) for it. You can cast the variable type explicitly to solve this: <code>String(x)</code> of <code>Number(x)</code>.
      </li>
    </ul>

    <h4>Do not mutate the parameters of a function</h4>
    <ul>
      <li>Create new variables that take over the value instead.</li>
    </ul>

    <h4>The use of callback functions</h4>
    <ul>
      <li>
        Not only provides more flexible code (more modular), but also adds a layer of abstraction (the higher-order function does not need to know how the cbfn works).
      </li>
    </ul>

    <h4>Conditional statements of only one line</h4>
    <ul>
      <li>Can be written by short-circuiting.</li>
    </ul>

    <h4>Don't rechain the same methods</h4>
    <ul>
      <li>
        Eg. <code>.map().filter().map().reduce().filter()</code> can cause performance issues. If you need multiple .map() methods, try merging them into a single one.
      </li>
    </ul>

    <h4>Don't chain methods that mutate the original</h4>
    <ul>
      <li>Eg. <code>.splice()</code></li>
    </ul>

    <h4>Use '_' for unused parameters</h4>
    <ul>
      <li>Eg. <code>arr.map((_, i) => i + 1);</code></li>
    </ul>

    <h4>When you have a list of exceptions</h4>
    <ul>
      <li>
        Place them in an array. You can perform a conditional <code>includes()</code> on it.
      </li>
    </ul>
    <pre><code class="language-javascript">
        // This also shows you can remove duplication by adding a generic method inside your method:
        const convertTitleCase = function (title) {
          const capitalize = str => str[0].toUpperCase() + str.slice(1);
          const exceptions = ['a', 'an', 'and', 'the', 'but', 'or', 'on', 'in', 'with'];
          const titleCase = title
            .toLowerCase()
            .split(' ')
            .map(word => (exceptions.includes(word) ? word : capitalize(word)))
            .join(' ');
          return capitalize(titleCase);
        };
    </code></pre>

    <h4>Never add functions as instance properties to constructor functions</h4>
    <ul>
      <li>
        Every object that is created through that constructor will carry this function, which is bad for performance.
      </li>
    </ul>

    <h4>Use guard clauses (early return statement)</h4>

    <h4>Use ternary operators or logical operators instead of 'if'</h4>
    <ul>
      <li>Because they don't create a new code block</li>
    </ul>

    <h4>Use multiple 'if' statements instead of if / else if</h4>

    <h4>Avoid 'for' loops</h4>
    <ul>
      <li>Instead use array methods</li>
    </ul>

    <h4>Avoid callback-based asynchronous APIs</h4>
    <ul>
      <li>Instead use promise based API's</li>
    </ul>

    <h4>Consume promises with async/await instead of .then() and .catch()</h4>

    <h4>Use promises in parallel with promise.all() whenever possible</h4>

    <h4>Clean code</h4>
    <ul>
      <li>Use optional chaining and the nullish coalescing operator</li>
    </ul>
    Bad code:
    <pre><code class="language-javascript">
        var lim;
        if (limits[user]) {
          lim = limits[user];
        } else {
          lim = 0;
        }
    </code></pre>
    <p>Better code:</p>
    <pre><code class="language-javascript">
    const limit = limits[user] ? limits[user] : 0;
    </code></pre>
    <p>Best code:</p>
    <pre><code class="language-javascript">
    const limit = limits?.[user] ?? 0;
    // - limits?.[user] returns undefined if the 'limits' variable is undefined or null
    //   (otherwise TypeError: Cannot read property 'user' of null/undefined is thrown)
    // - limits?.[user] ?? 0 returns 'undefined' if the left hand value is undefined or null
    // - Both ?. and ?? check if the previous value is null or undefined
    </code></pre>

    <h4>Prevent side-effects</h4>
    <ul>
      <li>Avoid global variables. You should pass variables as arguments as much as possible</li>
      <li>Functions should not mutate the parameters they receive, instead they should create a copy of those parameters</li>
    </ul>

    <p>Wrong</p>
    <pre><code class="language-javascript">
        const addExpense = function (value, description, user = &#096jonas&#096) {
          user = user.toLowerCase(); // mutating passed parameter
          if (value <= getLimit(user)) {
            budget.push(&#123value: -value, description, user&#125); // manipulating global variable
          }
        };

        addExpense(budget, spendingLimits, 10, &#096Pizza 🍕&#096);
        addExpense(budget, spendingLimits, 100, &#096Going to movies 🍿&#096, &#096Matilda&#096);
        addExpense(budget, spendingLimits, 200, &#096Stuff&#096, &#096Jay&#096);
    </code></pre>

    <p>Right</p>
    <pre><code class="language-javascript">
        const addExpense = function (state, limits, value, description, user = &#096jonas&#096) {
          const cleanUser = user.toLowerCase(); // copying given parameter
          return value <= getLimit(limits, cleanUser)
            ? [ ...state, &#123 value: -value, description, user: cleanUser &#125 ]
            : state; // returning a mutated copy of the passed parameter
        };

        // every call will get passed the result of the previous one, instead of constantly manipulating the global variable
        // However in reality this would be done using composing or currying
        const newBudget1 = addExpense(budget, spendingLimits, 10, &#096Pizza 🍕&#096);
        const newBudget2 = addExpense(newBudget1, spendingLimits, 100, &#096Going to movies 🍿&#096, &#096Matilda&#096);
        const newBudget3 = addExpense(newBudget2, spendingLimits, 200, &#096Stuff&#096, &#096Jay&#096);
    </code></pre>

    <p>Wrong</p>
    <pre><code class="language-javascript">
        const checkExpenses = function () {
          for (const entry of newBudget3) // accessing global variable
            if (entry.value < -getLimit(limits, entry.user)) entry.flag = &#096limit&#096; // accessing global variables and mutating original object
        };
    </code></pre>

    <p>Right</p>
    <pre><code class="language-javascript">
        const checkExpenses = (state, limits) =>
          state.map(entry =>
            entry.value < -getLimit(limits, entry.user)
              ? &#123 ...entry, flag: &#096limit&#096 &#125
              : entry
          );
    </code></pre>

    <p>Wrong</p>
    <pre><code class="language-javascript">
        const logBigExpenses = function(limit){
          let output = &#096&#096; // a pure function will almost never have &#096let&#096, but always const
          for (const entry of budget) // this is an imperative way of coding, not a declarative
            output += // manipulating a function scoped variable here
            entry.value <= -bigLimit ? &#096&#036&#123entry.description.slice(-2)&#125 &#096 : &#096&#096;
          output = output.slice(0, -2);
          console.log(output);
        };
        logBigExpenses(500);
    </code></pre>

    <p>Right</p>
    <pre><code class="language-javascript">
        const logBigExpenses = function (state, bigLimit) { // passing arguments instead of using globals
          const bigExpenses = state // creating a new variable instead of manipulating the original
            .filter(entry => entry.value <= -bigLimit) // using declarative functions
            .map(entry => entry.description.slice(-2))
            .join(&#096 / &#096);

          console.log(bigExpenses);
        };

        logBigExpenses(finalBudget, 500);
    </code></pre>
  </div><!-- end best practices -->

</div> <!-- end extra -->
`;
